/*
  * Common global custom js file with functions/methods
  * Fine Jewelry
  * Vow, Design files
  * Helper functions
*/
function safeGA(){ return typeof window.ga === 'function'; }
function gaSend(){ if (safeGA()) ga.apply(null, arguments); }

function debounce(fn, delay){
  var t; return function(){ clearTimeout(t); var a=arguments, c=this; t=setTimeout(function(){ fn.apply(c,a); }, delay); };
}

async function safeCopy(text){
  try{ if (navigator.clipboard?.writeText){ await navigator.clipboard.writeText(text); return true; } }catch(e){}
  var $tmp=$('<input>'); $('body').append($tmp); $tmp.val(text).select();
  var ok=false; try{ ok=document.execCommand('copy'); }catch(e){}
  $tmp.remove(); return ok;
}

function throttle(fn, wait){
  var last=0, timer;
  return function(){
    var now=Date.now(), ctx=this, args=arguments, remaining=wait-(now-last);
    if (remaining<=0){ last=now; fn.apply(ctx,args); }
    else { clearTimeout(timer); timer=setTimeout(function(){ last=Date.now(); fn.apply(ctx,args); }, remaining); }
  };
}

var apiVersion = "/admin/api/2023-04/";  /* Old-Version: "/admin/api/2020-01/"; */
var originalLeadTimeMsg;

$("body").css("overflow", "visible");

/* ===== Load mini-cart items on page load ===== */
window.addEventListener('DOMContentLoaded', (event) => {
  getCartItem();
  var width = $(window).width(); 
  var height = $(window).height(); 
  if (!(window.location.href.indexOf("cart") > -1) && width > 767) {
    $('#js-cart-drawer').hover(function() {
      $("#js-cart-visibility").removeClass("hide");
    });
    $('#js-cart-visibility').hover(function() {
      $("#js-cart-visibility").removeClass("hide");
    });
    $('#js-cart-visibility').mouseleave(function() {
      $("#js-cart-visibility").addClass("hide");
    });
    $('#js-cart-drawer').mouseleave(function() {
      $("#js-cart-visibility").addClass("hide");
    });
  } else {
    $('#js-cart-drawer').click(function() {
      
        window.location.href = "/cart";
      
    })
  }
});

$(document).ready(function () {
  if (pageType === 'product') {
    var updateDropdownValues = currentProductJson ? currentProductJson.tags.filter(s => s.startsWith('update-dropdown-values: ')).map(s => s.replace('update-dropdown-values: ', '')) : [];
    if(updateDropdownValues && updateDropdownValues.length !== 0){
      updateDropdwonValuesInUI(updateDropdownValues[0]);
    }
    /* Redirecting the Diamond product to Ring Builder Page */
    if(currentProductJson?.type === 'Diamond' && pageType === 'product') window.location.href = ringBuilderPageUrl
  }
  
  $(".acordian__link").on("click", function() {
    var $button = $(this).find("button.select_diamond");
    var currentState = $button.attr("aria-expanded") === "true";
    $(this).find(".priceSortIcon").toggleClass("priceSortIcon-rotate")
    $(this).parent().next().toggleClass("acordian-body-hide")
    $button.attr("aria-expanded", !currentState);
  })
  $(".checkoutNowButton").on("click", function (){
    isCheckoutNowButtonPressed = true;
  })
  $(".ProductForm__AddToCart").click(function () {
    isCheckoutNowButtonPressed = false;
  })
  /* Check VIP & VVIP Visitior Via URL Params and saving the data to local storage */
  var checkVisitorCustomer = getParameterByName("sale")
  var isVipUser = "KWXILNKFCEVLEZO";   //unique param for VIP visitor
  var isVVipUser = "DZSKQHMPKQOZVFS";  // unique param for VVIP visitor
  /* Saving Visitors Info to Localstorage :For VIP User*/
  if (checkVisitorCustomer && checkVisitorCustomer.indexOf(isVipUser) !== -1) {
    localStorage.setItem("setVisitingCustomer", getVIPParam)
  }
  /* Saving Visitors Info to Localstorage :For VVIP User*/
  if (checkVisitorCustomer && checkVisitorCustomer.indexOf(isVVipUser) !== -1) {
    localStorage.setItem("setVisitingCustomer", getVVIPParam)
  }
  /* Locked Private Sale: Check VIP User */
  if (checkVIPUser && checkVIPUser === true && showVIPPrivateSale && showVIPPrivateSale === true) {
    localStorage.setItem("setVisitingCustomerPrivateSale", getVIPParamPrivateSale)
  }
  /* Locked Private Sale: Check VVIP User */
  if (checkVVIPUser && checkVVIPUser === true && showVVIPPrivateSale && showVVIPPrivateSale === true) {
    localStorage.setItem("setVisitingCustomerPrivateSale", getVVIPParamPrivateSale)
  }
  
  $(".ProductItem__Price .money").each(function (index) {
    var currentPrice = $(this).text()
    // UI display adjustment
    if (currentPrice.endsWith(".00")) {
      currentPrice = currentPrice.replace(".00", "")
      $(this).text(currentPrice)
    }
  });
  $('.HorizontalList,.Header__Logo').hover(function () {
    $('.Popover').attr('aria-hidden', true)
    $("body").removeClass("noscroll")
    $("html").removeClass("no-scroll")
    $('.ProductForm__Item').attr('aria-expanded', 'false')
  })
  // Already diamond popup modal close
  $(".already-diamond-popup-close").on('click', function () {
    $("#already-diamond-popup").removeClass("open")
  })
  // Set URI first part before query parameter
  if (window.location.search.includes("utm_source=designfile")) {
    localStorage.setItem("designFileSource", window.location.href.split("?variant")[0])
  }
  
  $('#openEngravingModal').click(() => {
    if (localStorage.getItem("selectingDiamondFor") && localStorage.getItem("selectingDiamondFor").includes(localStorage.getItem("designFileSource"))) {
      gaSend('send', {
        hitType: 'event',
        eventCategory: 'Design file',
        eventAction: "Design File Product Details",
        eventLabel: "Design File Product Details",
        hitCallback: function (g) {
        }
      });
    }
  })
  
  // Closing the mobile drawer automatically if wishlist model is opened
  $("a[href='#swym-wishlist']").on("click", function () {
    jQuery("#sidebar-menu").attr("aria-hidden", true)
  })

  /* When the user gets on search result page, run this run to show Sale Price on that page... */
  showSalePriceOnSearchBar()

  // Get all elements with class "show-hover-img"
  var hoverImgs = document.querySelectorAll('.show-hover-img');
  hoverImgs.forEach(hoverImg => {
    hoverImg.addEventListener('mouseover', function() {
      this.setAttribute('aria-hidden', 'false');
    });
    hoverImg.addEventListener('mouseout', function() {
      this.setAttribute('aria-hidden', 'true');
    });
  });
  
  $(".CollectionToolbar__Item--filter").on('click', function(){
    setTimeout(function(){
      $("body").removeClass("is-rc-close").addClass("is-rc-open")  
    },50);
  })
})

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})
var fraction = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

var formatPriceFunc = (price) => {
  price = price.toString();  // Convert the price to a string to ensure we're working with a string value.
  price = price.replace(/\.00$/, ''); // Use a regular expression to remove trailing ".00" and preserve other decimals.
  return price;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\s+/g, " "));
}

function getQueryParams(params) {
  var href = decodeURIComponent((window.location.href).replace(/\+/g, '%20'));
  var reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
  var queryString = reg.exec(href);
  return queryString ? queryString[1] : null;
}

Array.prototype.max = function () {
  return Math.max.apply(null, this);
};

Array.prototype.min = function () {
  return Math.min.apply(null, this);
};

function commafy(num) {
  var str = num.toString().split('.');
  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  if (str[1] && str[1].length >= 4) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return str.join('.');
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

var moneyFormat = wNumb({
  decimals: 0,
  thousand: ',',
  prefix: '$'
});

var caratFormat = wNumb({
  mark: '.',
  thousand: ',',
  decimals: 2,
});

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}

/*** General/Common conversions ***/
function removeChar(name) {
  return name && name !== '' ? (name.replace(/\s/g, '')) : ''
}

function removeCharWithLowerCase(name) {
  return name && name !== '' ? (name.replace(/\s/g, '')).toLowerCase() : ''
}

function removeDoller(price) {
  return parseFloat(`${price}`.replace(/\s/g, '').replace('$', '').replace(',', ''))
}

function productPrice(price) {
  return parseFloat(price / 100)
}

/* Common function to call API Calls */  /* ==== diamondApiUrl added on 18 Nov 2024 ==== */
function commonApiCalls(data, cb) {
  fetch(diamondApiUrl + '/getshopifyapi', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then((data) => {
    cb(data)
  })
}

/* Common Function to call Klaviyo Email's Capture */
function commonKlaviyoCallscapture(data, cb) {
  try {
    fetch(portalApiUrl + '/shopify_capture_klaviyo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then((data) => {
      cb(data)
    })
  } catch (error) {
    console.log('An error occurred:', error);
  }
}

function showToasterPopup(message) {
  if (message !== '') {
    $(".toast__content").text(message)
    $(".toast__cell").removeClass("close")
  } else {
    $(".toast__cell").addClass("close")
    $(".toast__content").text('')
  }
  $(".toast__close").on('click', () => {
    $(".toast__cell").addClass("close")
    $(".toast__content").text('')
  })
}

function closedAction() {
  $(".close-modal-popup").on('click', function (event) {
    if ($("#out_off_stack_product").hasClass('open')) {
      $("#out_off_stack_product").removeClass("open")
      $("body,html").removeClass("modal-window-open");
    }
    if ($("#product_info").hasClass('open')) {
      $("#product_info").removeClass("open")
      $(".modal-window-body-cart").find(".modal-window-content").html('')
      var url = window.location.href.split('?')[0];
      var prevUrl;
      if (window.history && currentProductJson && currentProductJson.id != '7016921235544') {
        window.history.pushState({ prevUrl: window.location.href }, null, url);
      }
      if (window.history && !currentProductJson) {
        window.history.pushState({ prevUrl: window.location.href }, null, url);
      }
      $("body,html").removeClass("modal-window-open");
    }
  })
  $(".Drawer__Close").on('click', function () {
    if ($("#sidebar-cart-drawer").attr('aria-hidden') === 'false') {
      $("#sidebar-cart-drawer").attr("aria-hidden", "true").removeAttr('tabindex', '-1');
      $(".PageOverlay").removeClass("is-visible");
    }
  })
}

(function ($) {
  closedAction();
});

function getProductFromShopify(handle, cb) {
  commonApiCalls({
    apiUrl: apiUrlPath + apiVersion + "products.json?handle=" + handle,
    method: 'GET'
  }, (data) => {
    if (data && data.products && data.products.length > 0) {
      var prod = data.products[0]
      cb(null, prod)
    } else {
      cb(null, null)
    }
  })
}

function changeSliderArrows() {
  var pre = '<svg class="Icon Icon--arrow-left" role="presentation" viewBox="0 0 11 21"><polyline fill="none" stroke="currentColor" points="10.5 0.5 0.5 10.5 10.5 20.5" stroke-width="1.25"></polyline></svg>';
  var next = '<svg class="Icon Icon--arrow-right" role="presentation" viewBox="0 0 11 21"><polyline fill="none" stroke="currentColor" points="0.5 0.5 10.5 10.5 0.5 20.5" stroke-width="1.25"></polyline></svg>';
  if (currentProductTemplate && currentProductTemplate === 'vow.engagement.rings') {
    $('.Product__Slideshow-vow').find('.flickity-prev-next-button.previous').addClass('RoundButton').html(pre)
    $('.Product__Slideshow-vow').find('.flickity-prev-next-button.next').addClass('RoundButton').html(next)
  } 
}

/** * Custom message display in 3 sec duration * **/
function showErrorMessage(message) {
  showToasterPopup(message);
  $(".toast__content").attr('aria-live', 'polite').attr('role', 'alert');
  setTimeout(() => {
    showToasterPopup('');
  }, 3000)
}

function deleteProduct(productId) {
  var body = {
    apiUrl: apiUrlPath + apiVersion + "products/" + productId + ".json",
    method: 'DELETE'
  }
  commonApiCalls(body, (data) => {
  })
}

function mobileslider(item) {
  var pid = $(item).attr('pid')
  var href = $(".product_redirecturl" + pid).attr("href");
  window.location.href = href;
}

/**
* This function returns variant info from vow product json
* @params
* product = json of product which has to be iterate
* diamond = diamond name which is actually option1 of product json
* metal = metal name which is actually option2 of product json
* design = design which is actually option3 of product json
**/
function getVowProductVariantInfo(product, diamond = null, metal = null, design = null) {
  var variantInfo = null
  if (product instanceof Object) {
    var metalOtherNames = getMetalOtherNames(metal)
    var diamondOtherNames = getDiamondOtherNames(diamond)
    
    if (diamond === 'Antique Style Cushion') diamondOtherNames = 'Antique-Style Cushion'
    if (diamond === 'Emerald (East/West)' || diamond === 'Emerald+(East/West)' || diamond === 'Emerald+ (East/West)' || diamond[0] === 'Emerald (East/West)') diamondOtherNames = 'Emerald (East/West)'
    if (diamond === 'Emerald (North/South)' || diamond === 'Emerald+(North/South)' || diamond === 'Emerald+ (North/South)' || diamond[0] === 'Emerald (North/South)') diamondOtherNames = 'Emerald (North/South)'
    product.variants.map(function (v, i) {
      if (v.option3){
        if (diamondOtherNames.indexOf(v.option1) !== -1 && metalOtherNames.indexOf(v.option2) !== -1 && v.option3 == design) {
          variantInfo = v
        }
      } else {
        if (diamondOtherNames.indexOf(v.option1) !== -1 && metalOtherNames.indexOf(v.option2) !== -1) {
          variantInfo = v
        }
      }
    })
    return variantInfo
  }
  return variantInfo
}

function getDiamondType() {
  var diamondType = getParameterByName("diamondType", window.location.href)
  if (diamondType) {
    if (diamondType === "Round" || diamondType === "Pear" || diamondType === "Oval" || diamondType === "Radiant" || diamondType === "Emerald" || diamondType === "Cushion") {
      return diamondType;
    } else {
      return diamondType;
    }
  } else {
    return "Round"
  }
}

function removeVowLocalstorageItems() {
  localStorage.removeItem("_raw_diamond_info")
  localStorage.removeItem('seletedDiamond')
  localStorage.removeItem("get_diamond_total_sale_price")
  localStorage.removeItem('select_main_product_data')  
  localStorage.removeItem('selectedDiamondCompleteData')
  localStorage.removeItem('selectedSettingInfo')
  localStorage.removeItem('_diamonds_to_compare')
  threeStepProcess();
}

/** * Common js for select diamond and compare diamond * **/
function redirectToProductDetailPage(diamondShape) {
  var grabSelectedProductInfo = localStorage.getItem("select_main_product_data")
  var selectedProductInfo = JSON.parse(grabSelectedProductInfo)
  var getProductHandle = "";
  if (selectedProductInfo){
    getProductHandle = selectedProductInfo.getProductHandle
  }
  var productHandle = getParameterByName("productHandle") || getProductHandle
  if (productHandle) {
    fetch("/collections/all/products/" + productHandle + ".json", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((data) => {
      vowProduct = data.product
      return vowProduct
    })
    .then(function (vowProduct) {
      // Getting parameters by name
      var selectedMetal= getParameterByName("metal")
      var decodedMetal = decodeURIComponent(selectedMetal);
      var metal = decodedMetal.replace(/\s+/g, '');
      var diamondTag = getParameterByName("diamondLabType")
      var diamondType = diamondShape ? diamondShape : getParameterByName("diamondType")
      var variantId = getParameterByName("variantId")
      var grabRingSize = getParameterByName("ringSize") || selectedProductInfo.getSelectedRingSize
      var grabDesignDetails = getParameterByName("designDetails")
      var selectDiamondFirstInfo = getParameterByName("selectDiamondFirst")
      var preCartStatus = getParameterByName("preCart")
      var productHandleDesignDetail = "Original Design"
      var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info");
      var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
      // Generating String
      redirectString = `/collections/${js_vow_collection_page}/products/${productHandle}?deleteselecteddiamond=false&`
      if (metal) redirectString += "&metal=" + metal
      if (grabRingSize) redirectString += "&ringSize=" + grabRingSize
      if (grabDesignDetails) redirectString += "&designDetails=" + grabDesignDetails
      if (productHandle) redirectString += "&productHandle=" + productHandle
      if (diamondType) {
        if (diamondType === 'Antique Style Cushion') diamondType = 'Antique-Style Cushion'
        if (diamondType === 'Antique Style Round') diamondType = 'Antique-Style Round'
        redirectString += "&diamondType=" + diamondType
      }
      if (diamondTag) {
        redirectString += "&diamondTag=" + diamondTag
      } else {
        redirectString += "&diamondTag=natural"
      }
      if (grabRawDiamondInfo && preCartStatus !== 'false') {
        redirectString += "&preCart=true"
      }
      if(selectDiamondFirstInfo) {
        redirectString += "&selectDiamondFirst=true"
      } 
      if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true') {
        redirectString += "&startwithsetting=true"
      } 
      /** * Getting the product metal and design detail from previous metal * **/
      if (variantId) {
        vowProduct.variants.map(function (data, i) {
          if (data.id == variantId) {
            productHandleDesignDetail = data.option3
            if (!metal) {
              metal = data.option2
            }
          }
        })
      }
      if (metal && diamondType && vowProduct) {
        var variantInfo = getVowProductVariantInfo(vowProduct, diamondType, metal, productHandleDesignDetail)
        if (variantInfo) redirectString += "&variant=" + variantInfo.id
      }
      window.location.href = redirectString
    })
  } else {
    console.log("Product handle is empty")
    var diamondType = diamondShape ? diamondShape.charAt(0).toUpperCase() + diamondShape.slice(1) : getParameterByName("diamondType")
    if (diamondType) {
      if(diamondType === "Antique-Style Cushion" || diamondType === "Antique Style Cushion" || diamondType === 'antiquestylecushion') diamondType = 'OldMine'
      if(diamondType === "Antique-Style Round" || diamondType === "Antique Style Round" || diamondType === 'antiquestyleround' || diamondType === 'antique-styleround') diamondType = 'European'
      window.location.href = `/collections/${js_vow_collection_page}?dp=${diamondType}`
    } else {
      window.location.href = `/collections/${js_vow_collection_page}`
    }
  }
}

/** * Diamond abbreviation * **/
function shapeId(name) {
  if (name == "Round") {
    return 'RD'
  } else if (name == "Oval") {
    return 'OV'
  } else if (name == "Pear") {
    return 'PS'
  } else if (name == "Radiant") {
    return 'RA'
  } else if (name == "Cushion") {
    return 'CU'
  } else if (name == "Emerald") {
    return 'EC'
  } else if (name == "European" || name == "Old Cut Round" || name === 'Antique-Style Round' || name === 'Antique Style Round') {
    return 'OE'
  } else if (name == "Old Mine" || name == "Old Cut Cushion" || name === 'Antique-Style Cushion' || name === 'Antique Style Cushion') {
    return 'OM'
  } else if (name == "Princess" || name == "princess") {
    return 'PR'
  } else {
    return name
  }
}

function vendorId(name) {
  if (name == "68119") {
    return 'RR'
  } else if (name == "56068") {
    return 'JR'
  } else if (name == "21684") {
    return 'RDI'
  } else if (name == "25333") {
    return 'HZ'
  } else if (name == "103644") {
    return 'RC'
  } else if (name == "66863") {
    return 'OM'
  } else if (name == "111935") {
    return 'DR'
  } else if (name == "117373") {
    return 'NK'
  } else if (name == "61666") {
    return 'BL'
  } else if (name == "80926") {
    return 'BC'
  } else if (name == "19029") {
    return 'DG'
  } else if (name == "100") {
    return 'SL'
  } else if (name == "101") {
    return 'GR'
  } else if (name == "102") {
    return 'FN'
  } else if (name == "106054") {
    return 'MD'
  } else if (name == "100332") {
    return 'Aarush'
  } else if (name == "1643772") {
    return 'EM'
  } else if (name == "1643001") {
    return 'EL'
  } else if (name) {
    return name
  } else {
    return null
  }
}

/** * Hide loader * **/
function hideFrameLoader(elm) {
  setTimeout(function () {
    $(`.framesloader${elm}`).fadeOut('slow', function () {
      $(`.framesloader${elm}`).remove();
    });
  }, 100);
}

function clearVowProductsAndSaveDiamond() {
  var vow_items_in_cart = localStorage.getItem("_vow_item_cart");
  var clicked_button_cert_id = localStorage.getItem("_clicked_button_cert_id");
  if (vow_items_in_cart) {
    var vowItems = JSON.parse(vow_items_in_cart)
    var clickedButtonCertId = JSON.parse(clicked_button_cert_id)
    // if vow items length is greater than 0
    if (vowItems.length > 0) {
      var updateVowItems = {}
      vowItems.length > 0 && vowItems.forEach((item) => {
        updateVowItems[item.id] = 0
      })
      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: { updates: updateVowItems },
        dataType: 'json',
        success: function (data) {
          // Clearing the localstorage items
          localStorage.removeItem("_vow_item_cart")
          localStorage.removeItem("_clicked_button_cert_id")
          $(`.already-diamond-popup-close`).trigger("click")
          $(`button.vow-btn-dark[data-cert_num="${clickedButtonCertId}"]`).trigger("click")
        },
        error: function (XMLHttpRequest, textStatus) {
          alert(textStatus)
        }
      })
    }
  }
}

/*** Directly getting the store all products so that No server involved ***/
function getProductByHandle(productHandle) {
  return fetch("/collections/all/products/" + productHandle + ".json", {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
}

jQuery.fn.serializeObject = function () {
  var o = {};
  var a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name] !== undefined) {
      if (!o[this.name].push) o[this.name] = [o[this.name]];
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
}
  
/* Close Modal Popup */
$(".modal-close-icon", 'body').on("click", function () {
  closedAction();
});

/* Formatting price by replacing zero with space */
var formatPriceFunc = (price) => {
  price = price.toString();
  price = price.replace(/\.00$/, '');
  return price;
}

/* Enabling Mini-Cart on hover after clicking on close popover */
$(".vow-modal-close").click(function () {
  $('#js-cart-drawer').css("pointer-events", "inherit");
})

/**
* Fetch Custom stone variants Array function
* Tag used: custom-stone-count, custom-stone-count-2, custom-stone-count-band, tennis-stone-count-lab, tennis-stone-count,locket-charms
**/
var customStoneDropDownOptions = [];
var customStoneDropDownOptionsTwo = [];
var customStoneDropDownOptionBand = [];
var customStoneDropDownOptionTennisLab = [];
var customStoneDropDownOptionTennisNatural = [];
var customStoneDropDownShakerCharms = [];
function customStoneArray(customStoneTag) {
  getProductByHandle(customStoneTag)
    .then(function (customStoneCountGhostProduct) {
      var optionsArr = []
      for (var i = 0; i < customStoneCountGhostProduct.product.variants.length; i++) {
        var filteredNames = $(customStoneCountGhostProduct.product.images).filter(function (idx) {
          return customStoneCountGhostProduct.product.images[idx].id === customStoneCountGhostProduct.product.variants[i].image_id
        });
        $(filteredNames).each(function () {
          customStoneCountGhostProduct.product.variants[i].imageUrl = this.src;
        })
      }
      return customStoneCountGhostProduct.product.variants;
    }).then(function (options) {
      if (customStoneTag == 'custom-stone-count') {
        customStoneDropDownOptions = options
        customStoneCount(currentVariantJson, currentProductJson.id, 'custom-stone-count')
        return customStoneDropDownOptions
      } else if (customStoneTag == 'custom-stone-count-2') {
        customStoneDropDownOptionsTwo = options
        customStoneCount(currentVariantJson, currentProductJson.id, 'custom-stone-count-2')
        return customStoneDropDownOptionsTwo
      } else if (customStoneTag == 'custom-stone-count-band') {
        customStoneDropDownOptionBand = options
        customStoneCount(currentVariantJson, currentProductJson.id, 'custom-stone-count-band')
        return customStoneDropDownOptionBand
      } else if (customStoneTag == 'tennis-stone-count-lab') {
        customStoneDropDownOptionTennisLab = options
        customStoneCount(currentVariantJson, currentProductJson.id, 'tennis-stone-count-lab')
        return customStoneDropDownOptionTennisLab
      } else if (customStoneTag == 'tennis-stone-count') {
        customStoneDropDownOptionTennisNatural = options
        customStoneCount(currentVariantJson, currentProductJson.id, 'tennis-stone-count')
        return customStoneDropDownOptionTennisNatural
      } else if (customStoneTag == 'locket-charms') {
        options.forEach(function (variant) {
          variant.customLeadTime =
            window.__locketCharmMetafields?.[variant.id] || '';
        });
        customStoneDropDownShakerCharms = options
        customStoneCount(currentVariantJson, currentProductJson.id, 'locket-charms')
        return customStoneDropDownShakerCharms
      }
    })
}

/*** Custom stone count function ***/
function getOptionsVals(v, optionVal) {
  var vals = 0;
  var productOptions = '';
  var getProductAction = jQuery("#pageActionProduct").text();
  if (getProductAction && getProductAction !== '') {
    productOptions = JSON.parse(jQuery("#pageActionProduct").text())
  }
  if (productOptions !== '' && (typeof productOptions === 'object')) {
    for (var k = 0; k < productOptions.length; k++) {
      if (productOptions && productOptions[k] &&
        (productOptions[k] === optionVal || productOptions[k] === optionVal ||
          productOptions[k].toLowerCase() === optionVal.toLowerCase() ||
          productOptions[k].toLowerCase() === optionVal.toLowerCase())) {
        switch (k) {
          case 0:
            vals = v.option1
            break
          case 1:
            vals = v.option2
            break
          case 2:
            vals = v.option3
            break
        }
      }
    }
    return vals;
  }
}

/* This function return the object for default values for selection when the product Id is given */
function getValuesByProductId(productId) {
  return defaultSelections.hasOwnProperty(productId) ? defaultSelections[productId] : null;
}

/* Grab Lead Time for Charm product */
const metafields = window.__locketCharmMetafieldsCart || {};
function getMetafieldLeadTime(variantId) {
  return metafields[String(variantId)] || '';
}

function computeLeadTime(variant) {
  const qty = variant.inventory_quantity;
  const inventoryManagement = variant.inventory_management;
  const metafieldLeadTime = getMetafieldLeadTime(variant.id);
  let leadTime = '';
  if (qty <= 0 || !inventoryManagement) {
    leadTime = metafieldLeadTime;
  } else if (qty > 0) {
    leadTime = 'In Stock';
  } 
  return leadTime;
}

function customStoneOptions(property, index, lineItem) {
  var dropdownOption = customStoneDropDownOptions;
  var isLocketCharmProduct = false;
  if (lineItem.properties && lineItem.properties._customStoneTag === "custom-stone-count-2") dropdownOption = customStoneDropDownOptionsTwo
  if (lineItem.properties && lineItem.properties._customStoneTag === "custom-stone-count-band") dropdownOption = customStoneDropDownOptionBand
  if (lineItem.properties && lineItem.properties._customStoneTag === "locket-charms") {
    dropdownOption = customStoneDropDownShakerCharms
    isLocketCharmProduct = true;
  }

  if (property && property.length > 1 && dropdownOption.length) {
    var variantId = property[1]
    var key = property[0]
    var productId = lineItem.product_id
    var filteredNames = $(dropdownOption).filter(function (idx) {
      return `${dropdownOption[idx].id}` === variantId
    });
    var objects = {}
    $(filteredNames).each(function () {
      objects = this
    })

    var objectTitle = objects.title.replace(/^.*?\s*\/\s*/, '');
    var divId = key+variantId+lineItem.id+index
    var lineVariantId = productId + lineItem.id + variantId
    var stoneOption = `<img src="` + objects.imageUrl + `" alt="` + objectTitle + `" class="stone-thumb"/><span class="stone-title">` + objectTitle + `</span>`;
    var stoneVal = objectTitle + ` (+$` + objects.price + `)`;
    var indexs = parseInt(index)
    var htmlDiv = '';
    var countkey = property[0]
    var stonekey = countkey.replace(/_/g, ' ')
    var keystonecount = stonekey.substring(7);
    if (isLocketCharmProduct) keystonecount = stonekey.substring(7).replace('Stone', 'Charm').trim();

    const variantMap = {};
    dropdownOption.forEach(v => {
      variantMap[String(v.id)] = v;
    });

    let initialLeadTime = '';
    if (isLocketCharmProduct) {
      const selectedVariant = variantMap[String(variantId)];
      if (selectedVariant) {
        initialLeadTime = computeLeadTime(selectedVariant);
      }
    }

    htmlDiv += `<div class="ProductForm__Option">`;
    htmlDiv += `<button id="btn-popover-` + lineVariantId + `-product-template-stone-options` + index + `" type="button" class="ProductForm__Item custom_stone_dropdown" aria-expanded="false" aria-controls="popover-` + lineVariantId + index + `-product-template-stone-options` + index + `">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="stone-lable">` + keystonecount + ` </span><span class="ProductForm__SelectedValue` + lineVariantId + index + ` stone-selected-value">` + stoneOption + `</span></span>`
    htmlDiv += `<input type="hidden" class="grab-charm-prices" value='` + objects.price + `'>`;
    htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_` + index + `]" class="custom_stone_` + lineVariantId + index + `_selectedvalue custom_variantId" value='` + variantId + `' data-required='true'>`;
    htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_Title_` + index + `]" class="custom_stone_title` + lineVariantId + index + `_selectedvalue" value='` + stoneVal + `'>`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    if (isLocketCharmProduct) htmlDiv += `<p class="charm-lead-time">${initialLeadTime}</p>`;
    htmlDiv += `</div>`;
    var htmlDivPop = '';
    htmlDivPop += `<div id="popover-` + lineVariantId + `-product-template-stone-options` + index + `" class="OptionSelector custom_stone_popover cart_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDivPop += `<header class="Popover__Header">`;
    htmlDivPop += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDivPop += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDivPop += `</svg></button>`;
    htmlDivPop += `<span class="Popover__Title Heading u-h4">Custom Stone</span>`;
    htmlDivPop += `</header>`
    htmlDivPop += `<div class="Popover__Content">`;
    htmlDivPop += `<div class="Popover__ValueList" data-scrollable="">`;

    for (var j = 0; j < dropdownOption.length; j++) {
      var variant = dropdownOption[j];
      var variantTitle = variant.title.replace(/^.*?\s*\/\s*/, '');
      var isDisabled = variant.inventory_quantity === 0 && variant.inventory_policy === 'deny';
      var leadTime = computeLeadTime(variant);
      htmlDivPop += `<button type="button" class="custom_stone_variant_option Popover__Value  Heading Link Link--primary u-h6 ${isDisabled ? 'cart-disabled-charm' : ''}" quantity="` + variant.inventory_quantity + `" oldId="` + lineVariantId + `" 
                        data-line-index="` + index + `" data-line-key="` + key + `" data-line-id="` + lineItem.key + `" action="cart" image-url="` + variant.imageUrl + `" parent-index="` + index + `" index="` + j + `" 
                        data-price="` + variant.price + `" data-title="` + variantTitle + `" data-value="` + variant.id + `" data-lead-time="${leadTime}" data-option-position="` + index + `">`;
      htmlDivPop += `<img src="` + variant.imageUrl + `" alt="` + variantTitle + `" class="stone-thumb" />`;
      htmlDivPop += `<span class="stone-title test">` + variantTitle + `</span>`;
      htmlDivPop += `</button>`;
    }
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;
    htmlDivPop += `</div>`;
    jQuery('#shopify-section-footer').after(htmlDivPop)
    jQuery('#' + divId).html("")
    jQuery('#' + divId).append(htmlDiv)
  } else {
    return ''
  }
  enableAddToCartButton()
  stopScreenFreeze()
}

/* This function updates the object for default values for selection when the product Id is given with updating keys */
function updateValuesByProductId(productId, updatedValues) {
  if (defaultSelections.hasOwnProperty(parseInt(productId))) {
    defaultSelections[productId] = Object.assign({}, defaultSelections[productId], updatedValues);
    return true;
  } else {
    return false;
  }
}

function customStoneCount(v, productId, customStoneCount) {
  var dropdownOption = customStoneDropDownOptions;
  var isLocketCharm = false;
  if (customStoneCount === "custom-stone-count-2")  dropdownOption = customStoneDropDownOptionsTwo
  if (customStoneCount === "custom-stone-count-band")  dropdownOption = customStoneDropDownOptionBand
  if (customStoneCount === "tennis-stone-count-lab")  dropdownOption = customStoneDropDownOptionTennisLab
  if (customStoneCount === "tennis-stone-count")  dropdownOption = customStoneDropDownOptionTennisNatural
  if (customStoneCount === "locket-charms") { 
    dropdownOption = customStoneDropDownShakerCharms
    isLocketCharm = true
  }

  if (dropdownOption.length) {
    jQuery('#custom-stones').html("")
    var productValues = getValuesByProductId(productId);
    /* ==== Fetching charm count through Custom Charm Count Dropdown ==== */
    var grabCharmCountValue = $(".charmcount_dropdown_title" + v.id + "_selectedvalue").val();
    var vals = getOptionsVals(v, 'Birthstone Count') || getOptionsVals(v, 'Stone Count') || getOptionsVals(v, 'Charm Count') || grabCharmCountValue
    var checkEngravingStyleOptions = currentProductJson.tags?.filter(s => s.includes('11/12/24 Personalized Gemstone Eternity Bands'));
    var dropdownLabel = 'Stone';
    checkEngravingStyleOptions && checkEngravingStyleOptions.length ?  dropdownLabel = 'Birthstone' : dropdownLabel = 'Stone';
    if (isLocketCharm) dropdownLabel = "Charm"
    
    var htmlDiv = ''
    var appendArray = []
    for (var i = 1; i <= vals; i++) {
      htmlDiv += `<div class="ProductForm__Option">`;
      htmlDiv += `<button id="btn-popover-` + productId + v.id + `-product-template-stone-options` + i + `" type="button" class="ProductForm__Item custom_stone_dropdown" aria-expanded="false" aria-controls="popover-` + productId + v.id + `-product-template-stone-options` + i + `">`;
      if ((customStoneCount === "tennis-stone-count" || customStoneCount === "tennis-stone-count-lab") && i === 1) {
        htmlDiv += `<span class="ProductForm__OptionName"><span class="stone-lable">`+ dropdownLabel +` ` + i + ` (Next to Clasp): </span><span class="ProductForm__SelectedValue` + productId + v.id + i + ` stone-selected-value">`
      } else {
        htmlDiv += `<span class="ProductForm__OptionName"><span class="stone-lable">`+ dropdownLabel +` ` + i + `: </span><span class="ProductForm__SelectedValue` + productId + v.id + i + ` stone-selected-value">`
      }
      if (productValues['stoneTitle_' + i + ''] !== 'Select' && productValues['stoneTitle_' + i + ''] !== 'Select') {
        htmlDiv += `<img src="` + productValues['imgUrl_' + i + ''] + `" alt="` + productValues['stoneTitle_' + i + ''] + `" class="stone-thumb">`
      }
      htmlDiv += `<span class="stone-title">` + productValues['stoneTitle_' + i + ''] + `</span>`
      htmlDiv += `</span></span>`
      if (productValues['stoneTitle_' + i + ''] !== 'Select' && productValues['stoneTitle_' + i + ''] !== 'Select') {
        htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_Title_` + i + `]" class="custom_stone_title` + productId + v.id + i + `_selectedvalue" value='` + productValues['stoneTitle_' + i + ''] + `' data-required='true'>`;
      } else {
        htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_Title_` + i + `]" class="custom_stone_title` + productId + v.id + i + `_selectedvalue" value='' data-required='true'>`;
      }
      htmlDiv += `<input type="hidden" name="properties[_Custom_Stone_` + i + `]" class="custom_stone_` + productId + v.id + i + `_selectedvalue custom_variantId" value='` + productValues['stoneId_' + i + ''] + `' data-required='true'>`;
      htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
      htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
      htmlDiv += `</svg>`;
      htmlDiv += `</button><div class="errormsg stone-error"></div>`; 
      htmlDiv += `<div id="popover-` + productId + v.id + `-product-template-stone-options` + i + `" class="OptionSelector custom_stone_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
      htmlDiv += `<header class="Popover__Header">`;
      htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
      htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
      htmlDiv += `</svg></button>`;
      htmlDiv += `<span class="Popover__Title Heading u-h4">Custom Stone</span>`;
      htmlDiv += `</header>`
      htmlDiv += `<div class="Popover__Content">`;
      htmlDiv += `<div class="Popover__ValueList" data-scrollable="">`;
      for (var j = 0; j < dropdownOption.length; j++) {
        var variant = dropdownOption[j];
        var variantTitle = variant.title.replace(/^.*?\s*\/\s*/, '');
        htmlDiv += `<button type="button" class="custom_stone_variant_option Popover__Value  Heading Link Link--primary u-h6" action="product" data-product_id="` + productId + `" oldId="` + productId + v.id + `" image-url="` + variant.imageUrl + `" parent-index="` + i + `" index="` + j + `" data-price="` + variant.price + `" data-compare-price="` + variant.compare_at_price + `" data-title="` + variantTitle + `" data-value="` + variant.id + `" data-option-position="` + i + `">`;
        htmlDiv += `<img src="` + variant.imageUrl + `" alt="` + variantTitle + `" class="stone-thumb"/>`;
        htmlDiv += `<span class="stone-title">` + variantTitle + `</span>`;
        if (isLocketCharm){
          htmlDiv += `<div class="popover-value-stock">
                        <span class="variant-lead-time">
                          <span class="dropdown-lead-time" data-custom-lead-time="" data-lt-var-custom-lead-time="` + (variant.customLeadTime || '') + `" data-lt-var-selling-policy="` + variant.inventory_policy + `" data-lt-var-id="`+ variant.id +`"></span> +$` + formatPriceFunc(variant.price) + `
                        </span> 
                      </div>`;
        }
        htmlDiv += `</button>`;
      }
      htmlDiv += `</div>`;
      htmlDiv += `</div>`;
      htmlDiv += `</div></div>`;

      if (isLocketCharm) {
        var savedLeadTime = productValues['leadTime_' + i];
        var savedCustomLeadTime = productValues['customLeadTime_' + i];
        
        /* Hiding Leadtime text if its- In Stock */
        var inStockClass = (savedLeadTime === 'In Stock' || savedCustomLeadTime === 'In Stock') ? ' in-stock-hidden-text' : '';

        htmlDiv += `<div class="charm-drop-lead-time lead-time-below-drop ${inStockClass}" data-parent-index="` + i + `">`;
        htmlDiv += `<span class="lead-time-charm-drop lead-time-` + i + `">`;
        if (savedCustomLeadTime && savedCustomLeadTime !== '') {
          htmlDiv += savedCustomLeadTime;
        } else if (savedLeadTime) {
          htmlDiv += savedLeadTime;
        }
        htmlDiv += `</span>`;
        htmlDiv += `<span class="stock-status-wrapper">`;

        if (savedLeadTime) {
          if (savedLeadTime.toLowerCase().includes('in stock')) {
            htmlDiv += `<span class="status-dot dot-green"></span>`;
            htmlDiv += `<span class="status-dot dot-orange hide"></span>`;
            htmlDiv += `<span class="stock-status-text">In Stock</span>`;
          } else if (savedLeadTime.toLowerCase().includes('sold out')) {
            htmlDiv += `<span class="status-dot dot-green hide"></span>`;
            htmlDiv += `<span class="status-dot dot-orange hide"></span>`;
            htmlDiv += `<span class="stock-status-text"></span>`;
          } else {
            htmlDiv += `<span class="status-dot dot-green hide"></span>`;
            htmlDiv += `<span class="status-dot dot-orange"></span>`;
            htmlDiv += `<span class="stock-status-text">Made to Order</span>`;
          }
        } else {
          htmlDiv += `<span class="status-dot dot-green hide"></span>`;
          htmlDiv += `<span class="status-dot dot-orange hide"></span>`;
          htmlDiv += `<span class="stock-status-text"></span>`;
        }
        htmlDiv += `</span></div>`;
      }

      if (appendArray.indexOf(i) === -1) {
        appendArray.push(i)
      }
    }
    jQuery('#custom-stones').append(htmlDiv);

    /* ===== Sync selectedAddons with currently rendered charm slots ===== */
    var lockerCharmProduct = currentProductJson ? currentProductJson.tags.filter(s => s.includes('locket-charms')) : [];
    if (lockerCharmProduct.length && originalBasePrice !== null) {
      // Clear all existing stone addon entries first
      Object.keys(selectedAddons).forEach(function(key) {
        if (key.startsWith('stone_')) {
          delete selectedAddons[key];
        }
      });

      // Re-populate from the currently selected variant IDs in each slot
      for (var slotIndex = 1; slotIndex <= vals; slotIndex++) {
        var selectedVariantId = productValues['stoneId_' + slotIndex];
        if (selectedVariantId) {
          var matchedVariant = customStoneDropDownShakerCharms.find(function(v) {
            return String(v.id) === String(selectedVariantId);
          });
          if (matchedVariant) {
            var price = parseFloat(matchedVariant.price);
            if (price > 1000) price = price / 100;
            selectedAddons['stone_' + slotIndex] = price;
          }
        }
      }

      // Recalculate and update the displayed price
      var totalAddonPrice = 0;
      Object.values(selectedAddons).forEach(function(val) {
        totalAddonPrice += val;
      });
      var finalPrice = originalBasePrice + totalAddonPrice;
      const num = Number(finalPrice);
      const formattedPrice = Number.isInteger(num) ? num.toLocaleString() : num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      $('#appendReg').text('$' + formattedPrice);

      updateSalePrice();   /* keeps VIP/VVIP sale line in sync */

      if (originalCompareAtPrice !== null && originalCompareAtPrice > 0) {
        var totalCompare = 0;
        Object.values(selectedAddons).forEach(function(val) { totalCompare += val; });
        var finalCompare = originalCompareAtPrice + totalCompare;
        $('#appendCompareAt').text('$' + formatPriceFunc(Number(finalCompare).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })));
      }
    }
    
    /* Inserting #custom-stones after the Birthstone Count element */
    if (jQuery('.Birthstone.Count.ProductForm__Option.ProductForm__Option--labelled').length) {
      jQuery('#custom-stones').insertAfter(jQuery('.Birthstone.Count.ProductForm__Option.ProductForm__Option--labelled').first());
    }

    /* Inserting #custom-stones after the Custom Charm Stone Count */
    if (jQuery('#charmCountWrapper').length) {
      jQuery('#custom-stones').insertAfter(jQuery('#charmCountWrapper').first());
    }
    /* Enabling Add to cart button */
    injectDropDownLeadTime();
    enableAddToCartButton()
    setClickActionStone()
    stopScreenFreeze()
  }
}

// Cache leadtime Data
window.leadTimeCache = window.leadTimeCache || {};

/* ==== Grab & Inject Leadtime to the dropdown variants ==== */
function injectDropDownLeadTime() {
  const $elements = $('.dropdown-lead-time');
  
  if (!$elements.length) return;

  // Collect unique IDs
  const variantIds = [
    ...new Set(
      $elements.map(function () {
        return Number($(this).data('lt-var-id'));
      }).get()
    )
  ];

  // Find IDs not already cached
  const idsToFetch = variantIds.filter(id => 
    window.leadTimeCache[id] === undefined
  );

  // If we need new data, fetch it
  if (idsToFetch.length) {
    $.ajax({
      url: `${multiLeadTimeApiUrl}/variants-leadtime`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ variantIds: idsToFetch }),
      success: function (response) {
        if (response.status && Array.isArray(response.data)) {
          response.data.forEach(item => {
            window.leadTimeCache[item.id] = item.availableToSell;
          });
        }
        appendLeadTime(); // Always apply after fetch
      }
    });
  } else {
    appendLeadTime(); // No fetch needed, just append
  }

  function appendLeadTime() {
    $elements.each(function () {
      const $el = $(this);
      const id = Number($el.data('lt-var-id'));
      const policy = $el.data('lt-var-selling-policy');
      const customLeadTime = $el.data('lt-var-custom-lead-time');
      const stock = window.leadTimeCache[id];

      if (stock === undefined) return;
      
      // ✅ In Stock
      if (stock > 30) {
        $el.text('In Stock');
      }
      else if (stock > 0 && stock <= 30) {
        $el.text('In Stock');
        $el.attr('data-custom-lead-time',`In Stock`)
        // $el.attr('data-custom-lead-time',`Only ${stock} left`)
      }
      // ✅ Continue selling when out of stock → show custom lead time
      else if (stock <= 0 && policy === 'continue') {
        if (customLeadTime) {
          $el.text('Made to Order');
          $el.attr('data-custom-lead-time',customLeadTime)
        } else {
          $el.text('Made to Order'); // fallback
        }
      }
      // ✅ Deny policy → Sold Out
      else if (policy === 'deny') {
        $el.text('Sold Out');
        const $btn = $el.closest('button');
        $btn.addClass('is-disabled charm-disabled-state');
        $btn.prop('disabled', true);
      }
      // ✅ Fallback
      else {
        $el.text('Made to Order');
      }
    });
  }
}

function closedPopOver(action_control) {
  if (action_control.indexOf('womensize') === -1 || action_control.indexOf('mensize') === -1) {
    jQuery(".womensize_dropdown_popover,.mensize_dropdown_popover").attr("aria-hidden", true)
  }
}

function setClickActionStone() {
  jQuery(".custom_stone_dropdown").click(function (e) {
    e.stopImmediatePropagation()
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        tops = pos.top - 50 - scrollHeight
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        setTimeout(function () {
          $(".PageOverlay").addClass('is-visible')
          tops = windowWidth - 140
        }, 100);
      }
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
    $('body').click(function () {
      $(".PageOverlay").removeClass("is-visible")
    });
    //$('body').css("overflow", "hidden");
  })
  popoverClosed()
}

/* Applying condition on clicking on Pageoverlay classs */
jQuery(".PageOverlay").click(function () {
  var divId = jQuery(this).attr('id')
  var colrpop = jQuery(".color_dropdown_popover").attr('aria-hidden');
  var fontsrpop = jQuery(".fontfamily_dropdown_popover").attr('aria-hidden');
  var mensrpop = jQuery(".mensize_dropdown_popover").attr('aria-hidden');
  var womensrpop = jQuery(".womens_dropdown_popover").attr('aria-hidden');
  var customsizepop = jQuery(".custom_size_dropdown_popover").attr('aria-hidden');
  var pearspop = jQuery(".pearstone_dropdown_popover").attr('aria-hidden');
  var emeraldrpop = jQuery(".emeraldstone_dropdown_popover").attr('aria-hidden');
  var caratweightpopup = jQuery(".carat_weight_dropdown_popover").attr('aria-hidden');
  var zodiaconepop = jQuery(".zodiac_one_dropdown_popover").attr('aria-hidden');
  var zodiactwopop = jQuery(".zodiac_two_dropdown_popover").attr('aria-hidden');
  var engravablepop = jQuery(".engravable_dropdown_popover").attr('aria-hidden');
  var engravabletwopop = jQuery(".engravable_dropdown_popover_two").attr('aria-hidden');

  if (colrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".color_dropdown_popover").attr('aria-hidden', true)
  } else if (mensrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".mensize_dropdown_popover").attr('aria-hidden', true)
  } else if (fontsrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".fontfamily_dropdown_popover").attr('aria-hidden', true)
  } else if (womensrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".womens_dropdown_popover").attr('aria-hidden', true)
  } else if (pearspop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".pearstone_dropdown_popover").attr('aria-hidden', true)
  } else if (emeraldrpop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".emeraldstone_dropdown_popover").attr('aria-hidden', true)
  } else if (caratweightpopup === "false") {
    $(this).removeClass("is-visible")
    jQuery(".carat_weight_dropdown_popover").attr('aria-hidden', true)
  } else if (zodiaconepop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".zodiac_one_dropdown_popover").attr('aria-hidden', true)
  } else if (zodiactwopop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".zodiac_two_dropdown_popover").attr('aria-hidden', true)
  } else if (engravablepop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".engravable_dropdown_popover").attr('aria-hidden', true)
  } else if (engravabletwopop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".engravable_dropdown_popover_two").attr('aria-hidden', true)  
  } else if (customsizepop === "false") {
    $(this).removeClass("is-visible")
    jQuery(".custom_size_dropdown_popover").attr('aria-hidden', true)
  }
  jQuery(".custom_stone_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== divId) {
      jQuery(".custom_stone_popover").attr('aria-hidden', true)
      $('.PageOverlay').removeClass("is-visible")
    }
  })
  jQuery(".fontfamily_dropdown_popover").each(function () {
    var ids = `btn-` + $(this).attr('id')
    if ($(this).attr('aria-hidden') === 'false' && ids !== divId) {
      jQuery(".fontfamily_dropdown_popover").attr('aria-hidden', true)
      $('.PageOverlay').removeClass("is-visible")
    }
  })
  /* Closing Searchbar on click of page overlay */
  if($('#Search').attr('aria-hidden') === 'false') {
    $('.Search__Close').trigger("click")
  }
})

$('body').click(function (e) {
  var noScroll = false
  var pageActionPro = jQuery("#pageActionProduct").text();
  var pageActionCart = jQuery("#pageActionCart").text();
  jQuery(".OptionSelector.Popover").each(function () {
    if ($(this).attr('aria-hidden') === "false") noScroll = true
  })
  if (noScroll) {
    jQuery("html").addClass("no-scroll")
  } else {
    if ($("#Search").attr("aria-hidden") === true) jQuery("html").removeClass("no-scroll");
  }
  if (noScroll && pageActionCart && pageActionCart === 'Cart' && $(e.target).closest(".CartItem__Property").length === 0) {
    jQuery("html").removeClass("no-scroll")
  }
  if (noScroll && pageActionPro && pageActionPro !== '' && $(e.target).closest(".ProductForm__Variants ").length === 0) {
    jQuery("html").removeClass("no-scroll")
  }
  $('body').removeClass('is-rc-open')
  $('html').removeClass("no-scroll")
});

function popoverClosed() {
  jQuery(".Popover__Close.Icon-Wrapper--clickable").click(function () {
    $(".PageOverlay").removeClass('is-visible')
    jQuery(this).parent().parent().attr('aria-hidden', true)
  })
  /* custom stone dropdown option selection function */
  $(".custom_stone_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = $(this).attr('data-value')
    var title = $(this).attr('data-title')
    var price = $(this).attr('data-price')
    var compareAtPrice = $(this).attr('data-compare-price')
    var index = $(this).attr('index')
    var parentIndex = $(this).attr('parent-index')
    var imageUrl = $(this).attr('image-url')
    var action = $(this).attr('action')
    var lineid = $(this).attr('data-line-id')
    var lineidIndex = $(this).attr("data-line-index")
    var lineidkey = $(this).attr("data-line-key")
    var oldId = $(this).attr("oldId")
    var product_id = $(this).attr("data-product_id")
    var lineidkeyTitle = `Custom_Stone_Title_` + lineidIndex
    var mainQuantity = $(this).attr("quantity")
    var updatedValues = {};
    var leadTimeText = $(this).find('.dropdown-lead-time').text();
    var customLeadTimeText = $(this).find('.dropdown-lead-time').attr('data-custom-lead-time');
    updatedValues['leadTime_' + parentIndex] = leadTimeText;
    updatedValues['customLeadTime_' + parentIndex] = customLeadTimeText;
    updatedValues['stoneTitle_' + parentIndex] = title;
    updatedValues['stoneId_' + parentIndex] = variantId;
    updatedValues['imgUrl_' + parentIndex] = imageUrl;
   
    /* Append leadtime below the dropdown for the product contains tag- locket-charms */
    var lockerCharmProduct = currentProductJson ? currentProductJson.tags.filter(s => s.includes('locket-charms')) : [];
    if(lockerCharmProduct.length){
      var leadTimeDropText = jQuery('.charm-drop-lead-time[data-parent-index="' + parentIndex + '"]');
      /* Update lead time text below dropdown */
      leadTimeDropText.find('.lead-time-charm-drop').text(leadTimeText).attr('data-var-id', variantId).addClass(`_Custom_Stone_${parentIndex}`);
      if (customLeadTimeText && customLeadTimeText !== '') leadTimeDropText.find('.lead-time-charm-drop').text(customLeadTimeText).attr('data-var-id', variantId).addClass(`_Custom_Stone_${parentIndex}`);
      leadTimeDropText.find('.status-dot').addClass('hide');

      /* Hiding Leadtime text if its- In Stock */
      if(leadTimeText === 'In Stock') {
        leadTimeDropText.find('.lead-time-charm-drop').parent().addClass('in-stock-hidden-text');
      } else {
        leadTimeDropText.find('.lead-time-charm-drop').parent().removeClass('in-stock-hidden-text');
      }
      
      if (leadTimeText.toLowerCase().includes('in stock')) {
        leadTimeDropText.find('.dot-green').removeClass('hide');
        leadTimeDropText.find('.stock-status-text').text('In Stock');
      } else if (leadTimeText.toLowerCase().includes('sold out')) {
        leadTimeDropText.find('.dot-green').addClass('hide');
        leadTimeDropText.find('.stock-status-text').text('');
      } else {
        leadTimeDropText.find('.dot-orange').removeClass('hide');
        leadTimeDropText.find('.stock-status-text').text('Made to Order');
      }
      leadTimeDropText.show();
    }

    /* Updating the default vaules in the Json in Global file */
    updateValuesByProductId(product_id, updatedValues);
   
    /* Update main price with the selected variant */
    if (action && action !== "cart"){
      let key = 'stone_' + parentIndex;
      if(price && Number(price) !== 0 && lockerCharmProduct.length) updateMainPrice(price, key);
      if(compareAtPrice && Number(compareAtPrice) !== 0 && lockerCharmProduct.length) updateCompareAtPrice(compareAtPrice, key)
      var stoneSalePrice = getStoneSalePrice(variantId, price);   
      if(stoneSalePrice && Number(stoneSalePrice) !== 0 && lockerCharmProduct.length) updateSalePrice(stoneSalePrice, key);  
    }

    if (!mainQuantity) mainQuantity = 1
    var divids = oldId + '' + parentIndex;
    var className = 'stone-thumb'
    var saveVariant = jQuery(".custom_stone_" + divids + "_selectedvalue").attr('value')
    var stoneOption = `<img src="` + imageUrl + `" alt="` + title + `" class="` + className + `"/><span class="stone-title"> ` + title + `</span>`;
    var stoneVal = title + ` (+$` + price + `)`;
    if (price === '0.00') stoneVal = title;
    jQuery(".ProductForm__SelectedValue" + divids).html(stoneOption)
    jQuery(".custom_stone_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".custom_stone_title" + divids + "_selectedvalue").attr('value', stoneVal)
    jQuery(this).closest(".custom_stone_popover").attr('aria-hidden', true)
    jQuery(".custom_stone_dropdown").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
    if (action && action === "cart" && saveVariant !== variantId) {
      var charmLeadTimeCart = $(this).attr('data-lead-time');
      $(".siteLoader").show()
      updateCartvalues(variantId, lineid, lineidIndex, lineidkey, lineidkeyTitle, stoneVal, charmLeadTimeCart)
    }
  })

  /* color drop down option selection function */
  jQuery(".color_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    defaultMetalVarId = variantId;
    var title = jQuery(this).attr('data-title')
    defaultMetalName = title;
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".color_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValue" + divids).html(dropdownOption)
    jQuery(".color_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".color_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".color_dropdown_popover").attr('aria-hidden', true)
    jQuery(".color_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey)
      }, 1000)
    }
  })

  /* Mens size drop down option selection function */
  jQuery(".mensize_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".mensize_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueMens" + divids).html(dropdownOption)
    jQuery(".mensize_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".mensize_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".mensize_dropdown_popover").attr('aria-hidden', true)
    jQuery(".mensize_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey)
      }, 1000)
    }
  })

  /* Font family drop down option selection function */
  jQuery(".fontfamily_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_font_family"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueFonts" + divids).html(dropdownOption)
    jQuery(".fontfamily_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".fontfamily_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".fontfamily_dropdown_popover").attr('aria-hidden', true)
    jQuery(".fontfamily_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
    /* Change Font family dynamically */
    var getCount = $('#customization').val().length;
    var getValue = $('#customization').val();
    var getFontFamily = $('.get_variant_font_family').text();
    $('#customization_count').val(getCount);
    $('#previewText').text(getValue);
    $('#previewText').css('font-family', getFontFamily.replaceAll(/\s/g, ''))
  })

  /* Womens size drop down option selection function */
  jQuery(".womensize_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var saveVariant = jQuery(".womensize_dropdown_" + variantId + "_selectedvalue").attr('value')
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueWomens" + divids).html(dropdownOption)
    jQuery(".womensize_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".womensize_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".womensize_dropdown_popover").attr('aria-hidden', true)
    jQuery(".womensize_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey)
      }, 1000)
    }
  })

  /* Charm Count drop down option selection function */
  jQuery(".charmcount_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValueCharmCount" + divids).html(dropdownOption)
    jQuery(".charmcount_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".charmcount_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".charmcount_dropdown_popover").attr('aria-hidden', true)
    jQuery(".charmcount_drop_down").attr('aria-expanded', false);

    /* ===== Clear selectedAddons for charm stones beyond the new count ===== */
    var lockerCharmProduct = currentProductJson ? currentProductJson.tags.filter(s => s.includes('locket-charms')) : [];
    if (lockerCharmProduct.length) {
      var newCharmCount = parseInt(title);

      // Remove addon prices for charm slots that no longer exist
      Object.keys(selectedAddons).forEach(function(key) {
        if (key.startsWith('stone_')) {
          var stoneIndex = parseInt(key.replace('stone_', ''));
          if (stoneIndex > newCharmCount) {
            delete selectedAddons[key];
          }
        }
      });

      // Recalculate and update the displayed price
      if (originalBasePrice !== null) {
        var totalAddonPrice = 0;
        Object.values(selectedAddons).forEach(function(val) {
          totalAddonPrice += val;
        });
        var finalPrice = originalBasePrice + totalAddonPrice;
        const num = Number(finalPrice);
        const formattedPrice = Number.isInteger(num) ? num.toLocaleString() : num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        $('#appendReg').text('$' + formattedPrice);
      }

      updateSalePrice();

      // Recalculate compare at price
      if (originalCompareAtPrice !== null && originalCompareAtPrice > 0) {
        var totalAddonPriceCompare = 0;
        Object.values(selectedAddons).forEach(function(val) {
          totalAddonPriceCompare += val;
        });
        var finalComparePrice = originalCompareAtPrice + totalAddonPriceCompare;
        $('#appendCompareAt').text('$' + formatPriceFunc(Number(finalComparePrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })));
      }

      customStoneCount(currentVariantJson, currentProductJson.id, 'locket-charms');
    }
  })

  /* Custom Diamond Coverage drop down option selection function */
  jQuery(".diamond_coverage_dropdown_variant_option").click(function () {
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="dropdown-title title_letter_case get_variant_selected_size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValue_Diamond_Coverage" + divids).html(dropdownOption)
    jQuery(".diamond_coverage_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".diamond_coverage_dropdown_popover").attr('aria-hidden', true)
    jQuery(".diamond_coverage_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $(".PageOverlay").removeClass('is-visible')
  })

  /* Pear stone drop down option selection function */
  jQuery(".pearstone_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var cloudPearStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('cloud-pear-stone')) : [];
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var imageUrl = jQuery(this).attr('image-url')
    pearStoneImg = imageUrl
    var price = jQuery(this).attr('data-price')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var lineidkeyTitle = `Pear_Stone_` + lineidIndex
    var divids = oldId;
    var className = 'stone-thumb-selected';
    var saveVariant = jQuery(".pearstone_dropdown_" + variantId + "_selectedvalue").attr('value');
    var stoneVal = title + ` (+$` + price + `)`;
    var dropdownOption = `<img src="` + imageUrl + `" alt="` + title + `" class="` + className + `"/><span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery(".ProductForm__SelectedValuePearstone" + divids).html(dropdownOption)
    jQuery(".pearstone_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    pearStoneValue = jQuery(".pearstone_dropdown_" + divids + "_selectedvalue").attr('value')
    jQuery(".pearstone_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    pearStoneTitle = jQuery(".pearstone_dropdown_title" + divids + "_selectedvalue").attr('value')
    jQuery(this).closest(".pearstone_dropdown_popover").attr('aria-hidden', true)
    jQuery(".pearstone_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    $("body").removeClass("noscroll")
    $(".PageOverlay").removeClass('is-visible')

    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey, lineidkeyTitle, stoneVal)
      }, 1000)
    }
    if (!cloudPearStone.length) previewColorCombinationButton("_toi_moi_image")
    if (cloudPearStone.length) injectCustomProductMainImage("pear-stone");
  })

  /* Emerald stone drop down option selection function */
  jQuery(".emeraldstone_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var cloudEmeraldStone = currentProductJson ? currentProductJson.tags.filter(s => s.includes('cloud-emerald-stone')) : [];
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var imageUrl = jQuery(this).attr('image-url')
    emeraldStoneImg = imageUrl;
    var price = jQuery(this).attr('data-price')
    var action = jQuery(this).attr('action')
    var lineid = jQuery(this).attr('data-line-id')
    var lineidIndex = jQuery(this).attr("data-line-index")
    var lineidkey = jQuery(this).attr("data-line-key")
    var oldId = jQuery(this).attr("oldId")
    var lineidkeyTitle = `Emerald_Stone_` + lineidIndex
    var divids = oldId;
    var className = 'stone-thumb-selected';
    var saveVariant = jQuery(".emeraldstone_dropdown_" + variantId + "_selectedvalue").attr('value');
    var stoneVal = title + ` (+$` + price + `)`;
    var dropdownOption = `<img src="` + imageUrl + `" alt="` + title + `" class="` + className + `"/><span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".ProductForm__SelectedValueEmeraldstone" + divids).html(dropdownOption)
    jQuery(".emeraldstone_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    emeraldStoneValue = jQuery(".emeraldstone_dropdown_" + divids + "_selectedvalue").attr('value');
    jQuery(".emeraldstone_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    emeraldStoneTitle = jQuery(".emeraldstone_dropdown_title" + divids + "_selectedvalue").attr('value');
    jQuery(this).closest(".emeraldstone_dropdown_popover").attr('aria-hidden', true)
    jQuery(".emeraldstone_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    $("body").removeClass("noscroll")
    if (action && action === "cart" && saveVariant !== variantId) {
      $(".siteLoader").show()
      setTimeout(() => {
        updateCartvalues(variantId, lineid, lineidIndex, lineidkey, lineidkeyTitle, stoneVal)
      }, 1000)
    }
    if (!cloudEmeraldStone.length) previewColorCombinationButton("_toi_moi_image");
    if (cloudEmeraldStone.length) injectCustomProductMainImage("emerald-stone");
  })

  /* Showing custom image on the selection of Cloud Emerald & Cloud Pear Stone */
  function injectCustomProductMainImage(stone) {
    (function () {
      var mainFlkty = Flickity.data($('.Product__Slideshow.flickity-enabled')[0]);
      if (!mainFlkty) return;
      
      var imageId = stone === "pear-stone" ? "33008072523864" : "33008072491096";
      var $thumb = $('.Product__SlideshowNavImage[data-image-id="' + imageId + '"]');
      if (!$thumb.length) return;

      var index = parseInt($thumb.attr('data-index'), 10) - 1;

      if (index >= 0 && index < mainFlkty.cells.length) {
        mainFlkty.select(index);
      }
    })();
  }

  /* Zodiac One drop down option selection function */
  jQuery(".zodiac_one_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".ProductForm__SelectedValueZodiacOne" + divids).html(dropdownOption)
    jQuery(".zodiac_one_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".zodiac_one_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    zodiacOneTitle = jQuery(".zodiac_one_dropdown_title" + divids + "_selectedvalue").attr('value');
    jQuery(this).closest(".zodiac_one_dropdown_popover").attr('aria-hidden', true)
    jQuery(".zodiac_one_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    previewColorCombinationButton("_zodiac_image")
  })

  /* Zodiac two drop down option selection function */
  jQuery(".zodiac_two_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="stone-title"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".ProductForm__SelectedValueZodiacTwo" + divids).html(dropdownOption)
    jQuery(".zodiac_two_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".zodiac_two_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    zodiacTwoTitle = jQuery(".zodiac_two_dropdown_title" + divids + "_selectedvalue").attr('value');
    jQuery(this).closest(".zodiac_two_dropdown_popover").attr('aria-hidden', true)
    jQuery(".zodiac_two_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    previewColorCombinationButton("_zodiac_image")
  })

  /* Engravable drop down option selection function */
  $(".engravable_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = $(this).attr('data-value')
    var title = $(this).attr('data-title')
    var fontFamily = $(this).attr('data-title')
    var textStyle = "none";
    var firstTextValue = $('#input-text-engraving-styles').val();
    var secondTextValue = $('#engravable_placement_dropdown_input_box').val();
    var optionalTextValue = $('#input-text-engraving-styles-optional').val();
    var optionalTextValueThree = $('#input-text-engraving-styles-optional-three').val();
    
    if (fontFamily === "Bernhard Tango") {
      fontFamily = "BernhardTangoBT"
    } else if (fontFamily === "Celine") {
      fontFamily = "BV Celine";
      textStyle = "uppercase";
    } else if (fontFamily === "Constane") {
      fontFamily = "Constane"
    } else {
      fontFamily = fontFamily.replace(/\s/g, "");
    }

    /* Managing space & styling for Font Preview's */
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const commonStyles = {
      "font-family": fontFamily,
      "text-transform": textStyle
    };
    if (isMobile) {
      commonStyles["padding-left"] = "15px";
    }

    var oldId = $(this).attr("oldId")
    $("body").addClass('is-rc-close')
    $("html").removeClass('no-scroll')
    $("#fontFamilyPreview").css(commonStyles).text(firstTextValue);
    if (!window.engravingFontTwoActive) {
      $("#fontFamilyPreviewTwo").css(commonStyles).text(secondTextValue);
    }
    $("#fontFamilyPreviewOptional").css(commonStyles).text(optionalTextValue);
    $("#fontFamilyPreviewOptionalThree").css(commonStyles).text(optionalTextValueThree);
    const capInputs = window.engravingFontTwoActive
      ? $('#input-text-engraving-styles, #input-text-engraving-styles-optional-three')
      : $('#input-text-engraving-styles, #engravable_placement_dropdown_input_box, #input-text-engraving-styles-optional-three');
    textStyle === 'none' ? capInputs.removeClass('capitalize-input') : capInputs.addClass('capitalize-input');
    
    var divids = oldId;
    var dropdownOption = `<span class="engravable-title" id="selected-engravable-font"> ` + title + `</span>`;
    var dropdownVal = title;

    $(".ProductForm__SelectedValueEngravable" + divids).html(dropdownOption)
    $(".engravable_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    $(".engravable_option_value" + divids + "_selectedvalue").attr('value', dropdownVal)
    $(this).closest(".engravable_dropdown_popover").attr('aria-hidden', true)
    $(".engravable_drop_down").attr('aria-expanded', false)
    $("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    previewColorCombinationButton("_engraving_image")
    changeInputNumbers()
  })

  /* Engravable Font Two (independent font for second text box) drop down option selection function */
  $(".engravable_dropdown_variant_option_two").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = $(this).attr('data-value')
    var title = $(this).attr('data-title')
    var fontFamily = $(this).attr('data-title')
    var textStyle = "none";
    var secondTextValue = $('#engravable_placement_dropdown_input_box').val();

    if (fontFamily === "Bernhard Tango") {
      fontFamily = "BernhardTangoBT"
    } else if (fontFamily === "Celine") {
      fontFamily = "BV Celine";
      textStyle = "uppercase";
    } else if (fontFamily === "Constane") {
      fontFamily = "Constane"
    } else {
      fontFamily = fontFamily.replace(/\s/g, "");
    }

    const isMobileTwo = window.matchMedia("(max-width: 767px)").matches;
    const commonStylesTwo = {
      "font-family": fontFamily,
      "text-transform": textStyle
    };
    if (isMobileTwo) {
      commonStylesTwo["padding-left"] = "15px";
    }

    var oldId = $(this).attr("oldId")
    $("body").addClass('is-rc-close')
    $("html").removeClass('no-scroll')
    $("#fontFamilyPreviewTwo").css(commonStylesTwo).text(secondTextValue);
    textStyle === 'none' ? $('#engravable_placement_dropdown_input_box').removeClass('capitalize-input') : $('#engravable_placement_dropdown_input_box').addClass('capitalize-input');

    var divids = oldId;
    var dropdownOption = `<span class="engravable-title" id="selected-engravable-font-two"> ` + title + `</span>`;
    var dropdownVal = title;

    $(".ProductForm__SelectedValueEngravableTwo" + divids).html(dropdownOption)
    $(".engravable_option_value_two" + divids + "_selectedvalue").attr('value', dropdownVal)
    $(this).closest(".engravable_dropdown_popover_two").attr('aria-hidden', true)
    $(".engravable_drop_down_two").attr('aria-expanded', false)
    $("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    changeInputNumbers()
  })

  /* Font drop down option selection function */
  jQuery(".font_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var fontFamily = jQuery(this).attr('data-title')
    var textStyle = "none";
    if (fontFamily === "Bernhard Tango") {
      fontFamily = "BernhardTangoBT"
    } else if (fontFamily === "Celine") {
      fontFamily = "BV Celine";
      textStyle = "uppercase";
    } else if (fontFamily === "Constane") {
      fontFamily = "Constane"
    } else if (fontFamily === "Seagram") {
      fontFamily = "Seagramtfb";
    } else {
      fontFamily = fontFamily.replace(/\s/g, "");
    }

    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="font-title" id="selected-font"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".ProductForm__SelectedValueFont" + divids).html(dropdownOption)
    jQuery(".font_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".font_option_value" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(".fontPreviewCustomize").css("font-family",fontFamily).css("text-transform", textStyle);
    jQuery("#fontName").val(title)
    jQuery(this).closest(".font_dropdown_popover").attr('aria-hidden', true)
    jQuery(".font_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
  })

  /* Engravable Placement drop down option selection function */
  jQuery(".engravable_placement_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value');
    var title = jQuery(this).attr('data-title');
    var oldId = jQuery(this).attr("oldId");
    var divids = oldId;
    var dropdownOption = `<span class="engravable-placement-title" id="selected-engravable-placement">` + title + `</span>`;
    var dropdownVal = title;
    var trimmedTitle = dropdownVal.trim().toLowerCase().replace(/\s/g, "");
    jQuery("body").addClass('is-rc-close');
    jQuery("html").removeClass('no-scroll');
    if (trimmedTitle === "center-2lines" || trimmedTitle === "bottomright-2lines" || trimmedTitle === "center" || trimmedTitle === "bothsides") {
      var grabFontFamily = $("#selected-engravable-font").text().trim();
      var textStyle = "none";
      if (grabFontFamily === "Celine") {
        grabFontFamily = "BV Celine";
        textStyle = "uppercase";
      } else if (grabFontFamily === "Constane") {
        grabFontFamily = "Constane";
      } else if (grabFontFamily === "Bernhard Tango") {
        grabFontFamily = "BernhardTangoBT";
      } else {
        grabFontFamily = grabFontFamily.replace(/\s+/g, "");
      }
      $(".Customization-DropDown-Placement").removeClass("hide");
      $("#engravingTextTwo").remove();
      $("#fontFamilyPreviewTwo").remove();
      $("#engravable_two").remove();
      $('form[action="/cart/add"]').append(`<input type="hidden" id="engravingTextTwo" class="engravable_customization_two_value" data-required="true" name="properties[Engraving_Text_2]" value=''/>`)
      document.querySelector('.engraving-wrapper.Customization-DropDown-Placement').insertAdjacentHTML('afterend', '<p id="fontFamilyPreviewTwo" style="font-family:'+ grabFontFamily +';text-transform: '+ textStyle +'" class="fontPreviewTwo"></p>');

      // if (trimmedTitle === "bothsides" || trimmedTitle === "center") {
      if (trimmedTitle === "bothsides") {
        window.engravingFontTwoActive = true;
        engravableDropDownTwo(currentVariantJson);
      } else {
        window.engravingFontTwoActive = false;
      }
    } else {
      $("#engravingTextTwo").remove();
      $("#fontFamilyPreviewTwo").remove();
      $("#engravable_two").remove();
      $(".Customization-DropDown-Placement").addClass("hide");
      $(".engravable-text-two-error").addClass("hide");
      window.engravingFontTwoActive = false;
    }
    
    customeInputBoxMaxLenghtSet(trimmedTitle);
    
    $('form[action="/cart/add"]').find(`input[name="properties[_engravingplacement]"]`).attr("value", title);
    jQuery(".ProductForm__SelectedValueEngravablePlacement" + divids).html(dropdownOption);
    jQuery(".engravable_placement_dropdown_" + divids + "_selectedvalue").attr('value', variantId);
    jQuery(".engravable_placement_option_value" + divids + "_selectedvalue").attr('value', dropdownVal);
    jQuery(this).closest(".engravable_placement_dropdown_popover").attr('aria-hidden', true);
    jQuery(".engravable_placement_drop_down").attr('aria-expanded', false);
    jQuery("body").addClass('is-rc-close');
    $(".PageOverlay").removeClass('is-visible');
    previewColorCombinationButton("_engraving_image")
  });
  
  function customeInputBoxMaxLenghtSet(trimmedTitle) {
    var engravablePlacementInputBox = $('.engravable_placement_dropdown_input_box');
    var inputTextEngravingStyles = $('#input-text-engraving-styles');
    var checkEngravingStyleOptions = currentProductJson.tags.filter(s => s.includes('engraving-style-options'));

    engravablePlacementInputBox.removeAttr('maxlength').val('')
    inputTextEngravingStyles.removeAttr('maxlength').val('')
    $('#fontFamilyPreview').text("")
    $('#fontFamilyPreviewTwo').text("")
    $('#engravingText').val("")
    $('#engravingTextTwo').val("")

    var maxlengthValueOne, maxlengthValueTwo;
    
    switch (trimmedTitle) {
      case 'rightvertical':
        maxlengthValueOne = 13;
        $("#engravingText").attr('data-required', true);
        break;
      case 'center-1line':
        maxlengthValueOne = 10;
        $("#engravingText").attr('data-required', true);
        break;
      case 'center-2lines':
        maxlengthValueOne = 7;
        maxlengthValueTwo = 10;
        $("#engravingText").attr('data-required', true);
        break;
      case 'center':
        maxlengthValueOne = 12;
        maxlengthValueTwo = 12;
        $("#engravingTextTwo").removeAttr('data-required');
        break;
      case 'bothsides':
        maxlengthValueOne = 3;
        maxlengthValueTwo = 8;
        $("#engravingTextTwo").removeAttr('data-required');
        $("#engraving-side-option-one").removeClass('hide').text('Engraving for Side A');
        $("#engraving-side-option-two").removeClass('hide').text('Engraving for Side B');
        break;    
      case 'bottomright-1line':
        maxlengthValueOne = 4;
        $("#engravingText").attr('data-required', true);
        break;  
      case 'bottomright-2lines':
        maxlengthValueOne = 2;
        maxlengthValueTwo = 4;
        $("#engravingText").attr('data-required', true);
        break;
      default:
        maxlengthValueOne = 10;
        maxlengthValueTwo = 10;
        break;
    }
    
    if(trimmedTitle === 'rightvertical' && checkEngravingStyleOptions.length) maxlengthValueOne = 12
    
    /* Input Character First */
    $("#charCountEnraging").text("0/" + maxlengthValueOne);
    inputTextEngravingStyles.attr('maxlength', maxlengthValueOne).off('input').on('input', function() {
      var currentLength = $(this).val().length;
      $('#charCountEnraging').text(currentLength + '/' + maxlengthValueOne);
    });
    /* Input Character Second */
    $("#character_count_display").text("0/" + maxlengthValueTwo);
    engravablePlacementInputBox.attr('maxlength', maxlengthValueTwo).off('input').on('input', function() {
      var currentLength = $(this).val().length;
      $('#character_count_display').text(currentLength + '/' + maxlengthValueTwo);
    });
  }

  /* ===== Setting Max length for Engraving Side Options Product: Rotating Diamond Ring ===== */
  var checkEngravingSideOptions = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engraving-side-options')) : [];
  if(checkEngravingSideOptions.length) {
    window.engravingFontTwoActive = true;
    customeInputBoxMaxLenghtSet('bothsides')
  }
  
  async function filterTagsContainingBespokeSize(tags) {
    var bespokeSizeTags = tags.filter(tag => tag.includes('bespoke-size-'));
    var bespokeSizes = bespokeSizeTags.map(tag => parseFloat(tag.replace('bespoke-size-', '')));
    return bespokeSizes;
  }
  
  /* Custom Size drop down option selection function */ 
  jQuery(".custom_size_dropdown_variant_option").click(async function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var customSizeBespokeFlashProductsSoldOut = currentProductJson ? currentProductJson.tags.filter(s => s.includes('is-bespoke-sold-out')) : [];
    var isOMSLeadTimeMadeToOrder = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-made-to-order')) : [];
    var isOMSLeadTimeInStock = currentProductJson ? currentProductJson.tags.filter(s => s.includes('fetch-oms-leadtime-in-stock')) : [];
    var bespokeSizeTags = await filterTagsContainingBespokeSize(currentProductJson.tags);
    var divids = oldId;
    var dropdownOption = `<span class="custom-size"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    
    jQuery(".ProductForm__SelectedValueCustomSize" + divids).html(dropdownOption)
    jQuery(".custom_size_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".custom_size_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".custom_size_dropdown_popover").attr('aria-hidden', true)
    jQuery(".custom_size_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')   

    var ifLeadTimeFieldIsPresent = jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).length
    if(customSizeBespokeFlashProductsSoldOut && customSizeBespokeFlashProductsSoldOut.length !== 0){
      $(".stock-level-message").html("Sold out")
    } else {
      if((bespokeSizeTags.includes(parseFloat(title)) && isOMSLeadTimeMadeToOrder.length === 0) || (bespokeSizeTags.includes(parseFloat(title)) && isOMSLeadTimeInStock.length)){
        $(".stock-level-message").html("Only 1 left in stock!")
        $('.inv-label--in-stock').removeClass('hide')
        $('.inv-label--out-stock').addClass('hide')
        if (ifLeadTimeFieldIsPresent > 0) {
          jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", 'Only 1 left in stock!')
        } else {
          jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="Only 1 left in stock!" />`)
        }
      } else {
        if((currentProductJson.type === "Lab Grown Engagement Rings" || currentProductJson.type === "Natural Engagement Ring") && isOMSLeadTimeMadeToOrder.length === 0 && isOMSLeadTimeInStock.length === 0){
          $(".stock-level-message").html("Estimated production time is 2 weeks.")
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
          if (ifLeadTimeFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", 'Estimated production time is 2 weeks.')
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="Estimated production time is 2 weeks." />`)
          }
        } else if(isOMSLeadTimeInStock.length) {
          if(grabEngagementRingsLeadTime.trim() === "") {
            grabEngagementRingsLeadTime = "Estimated production time is 2 weeks.";
          }
          $(".stock-level-message").html(grabEngagementRingsLeadTime)
          $('.inv-label--out-stock').removeClass('hide')
          $('.inv-label--in-stock').addClass('hide')
          if (ifLeadTimeFieldIsPresent > 0) {
            jQuery('form[action="/cart/add"]').find(`input[name="properties[Lead Time]"]`).attr("value", grabEngagementRingsLeadTime)
          } else {
            jQuery('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Lead Time]" value="${grabEngagementRingsLeadTime}" />`)
          }
        }
      }
    }
  })

  /* Combine Product Top 2 drop down option selection function */
  jQuery(".combine_product_dropdown_variant_option").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var variant = jQuery(this).attr('data-variant-id')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="combine-product"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".combine_product_dropdown_variant_option").attr("var-id", variant)
    jQuery(".ProductForm__SelectedValueCombineProduct" + divids).html(dropdownOption)
    jQuery(".product_combination_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".product_combination_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(".product_combination_dropdown_variant_id_top_two" + divids + "_selectedvalue").attr('value', variant)
    jQuery(this).closest(".combine_product_dropdown_popover").attr('aria-hidden', true)
    jQuery(".combine_product_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    updateLeadtimeLinkProducts(undefined)
    getCombinationImages("multiwayCloudLinkEarrings")
  })

  /* Combine Product Bottom 1 drop down option selection function */
  jQuery(".combine_product_dropdown_variant_option_bottom_one").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var variant = jQuery(this).attr('data-variant-id')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    var divids = oldId;
    var dropdownOption = `<span class="combine-product-bottom-one"> ` + title + `</span>`;
    var dropdownVal = title;
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')
    jQuery(".combine_product_dropdown_variant_option_bottom_one").attr("var-id", variant)
    jQuery(".ProductForm__SelectedValueCombineProductBottomOne" + divids).html(dropdownOption)
    jQuery(".product_combination_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".product_combination_dropdown_variant_id_bottom_one" + divids + "_selectedvalue").attr('value', variant)
    jQuery(".product_combination_bottom_one_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(this).closest(".combine_product_bottom_one_dropdown_popover").attr('aria-hidden', true)
    jQuery(".combine_product_bottom_one_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    updateLeadtimeLinkProducts(undefined)
    getCombinationImages("multiwayCloudLinkEarrings")
  })

  /* Combine Product Bottom 2 drop down option selection function */
  jQuery(".combine_product_dropdown_variant_option_bottom_two").click(function (e) {
    e.stopImmediatePropagation();
    var variantId = jQuery(this).attr('data-value')
    var variant = jQuery(this).attr('data-variant-id')
    var title = jQuery(this).attr('data-title')
    var oldId = jQuery(this).attr("oldId")
    jQuery("body").addClass('is-rc-close')
    jQuery("html").removeClass('no-scroll')

    var divids = oldId;
    var dropdownOption = `<span class="combine-product-bottom-two"> ` + title + `</span>`;
    var dropdownVal = title;

    jQuery(".combine_product_dropdown_variant_option_bottom_two").attr("var-id", variant)
    jQuery(".ProductForm__SelectedValueCombineProductBottomTwo" + divids).html(dropdownOption)
    jQuery(".product_combination_dropdown_" + divids + "_selectedvalue").attr('value', variantId)
    jQuery(".product_combination_bottom_two_dropdown_title" + divids + "_selectedvalue").attr('value', dropdownVal)
    jQuery(".product_combination_bottom_two_dropdown_variant_id_bottom_two" + divids + "_selectedvalue").attr('value', variant)
    jQuery(this).closest(".combine_product_bottom_two_dropdown_popover").attr('aria-hidden', true)
    jQuery(".combine_product_bottom_two_drop_down").attr('aria-expanded', false)
    jQuery("body").addClass('is-rc-close')
    $(".PageOverlay").removeClass('is-visible')
    updateLeadtimeLinkProducts(undefined)
    getCombinationImages("multiwayCloudLinkEarrings")
  })
}

function updateCartvalues(val, lineid, lineidIndex, lineidkey, lineidkeyTitle, titleVal, charmLeadTimeCart) {
  var dataQuantity = 1
  $(".siteLoader").show()
  fetch("/cart.js?action=update_cart_values_get")
    .then(response => response.json())
    .then(cartData => {
      if (cartData && cartData.items && cartData.items.length > 0) {
        // Getting the clicked item in obj object
        var obj = null
        cartData.items.map(function (d, i) {
          if (d.key == lineid) {
            obj = d
          }
        })
        return { item: obj, cartData }
      }
    })
    .then(function (objs) {
      var allStoneGhostProductsForClickedVariant = []
      var validCustomStoneVariantId = []
      var inValidCustomStones = []
      if (objs.cartData.items.length > 0) {
        // Getting all the ghost product associated with the clicked variant
        var a = []
        objs.cartData.items.map(function (item, i) {
          if (item.properties && item.properties._stone_associated_variant_id == objs?.item?.variant_id) {
            a.push(item)
          }
        })
        allStoneGhostProductsForClickedVariant = a.filter(onlyUnique);
        // Getting all valid ghost products for the clicked variant      
        if (allStoneGhostProductsForClickedVariant.length > 0) {
          var b = []
          for (i = 1; i < 6; i++) {
            if (objs.item && objs.item.properties["_Custom_Stone_" + i]) {
              b.push(parseInt(objs.item.properties["_Custom_Stone_" + i]))
            }
          }
          validCustomStoneVariantId = b.filter(onlyUnique);
        }
        var c = []
        // Getting all non valid items from cart
        for (x = 0; x < allStoneGhostProductsForClickedVariant.length; x++) {
          var item = allStoneGhostProductsForClickedVariant[x]
          if (validCustomStoneVariantId.indexOf(item.properties["_associated_unique_key"]) === objs?.item?.properties["_associated_unique_key"] ) {
            c.push(item)
          }
        }
        // Getting changed stone item from cart and using break statement to not get duplicates
        for (x = 0; x < allStoneGhostProductsForClickedVariant.length; x++) {
          var item = allStoneGhostProductsForClickedVariant[x]
          if (objs.item && objs.item.properties && objs.item.properties[lineidkey] == item.variant_id) {
            c.push(item)
            break;
          }
        }
        // Getting unique items to remove
        inValidCustomStones = c.filter(onlyUnique);
      }
      if (lineid) {
        var itemsToRemove = { [lineid]: 0 }
        // Pushing invalid items in item to remove
        if (inValidCustomStones.length > 0) {
          inValidCustomStones.map(function (item, i) {
            itemsToRemove[item.key] = 0
          })
        }
        var item = objs.item
        var dataToSend = { id: item.id, quantity: item.quantity, properties: item.properties }
        dataToSend['properties'][`${lineidkey}`] = val
        var stoneTitleKey = lineidkey.replace("Stone_", "Stone_Title_")
        dataToSend['properties'][`${stoneTitleKey}`] = titleVal
    
        var newItem = [{
          id: parseInt(val),
          quantity: item.quantity,
          properties: {
            _stone_associated_variant_id: `${item.variant_id}`,
            _associated_unique_key: item.properties["_associated_unique_key"],
            "Lead Time": charmLeadTimeCart || "",
            _time_added: Date.now()
          }
        }]
        
        newItem.push(dataToSend) // Pushing clicked item with updated properties
        /**
        * Cart change API is not updating the line item properties 
        * so removing the clicked item and adding it again with new properties
        **/
        fetch('/cart/update.js?action=update', {
          body: JSON.stringify({ updates: itemsToRemove }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function (cart) {
          return fetch('/cart/add.js?action=add', {
            body: JSON.stringify({ items: newItem }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
        })
        .then(function (cart) {
          setTimeout(() => {
            $("input").prop('disabled', false);
            window.location.reload()
          }, 2000)
        })
        .catch(function (error) {
          $(".siteLoader").hide()
        })
      }
    })
}

/* Close popover on select dropdown */
$(".Popover__ValueList").click(function () {
  $("body").css("overflow", "visible");
});

/*  Globle Accordian function  */
var accordion = $('body').find('[data-behavior="accordion"]');
var expandedClass = 'is-expanded';

$.each(accordion, function () { // loop through all accordions on the page
  var accordionItems = $(this).find('[data-binding="expand-accordion-item"]');
  $.each(accordionItems, function () { // loop through all accordion items of each accordion
    var $this = $(this);
    var triggerBtn = $this.find('[data-binding="expand-accordion-trigger"]');
    var setHeight = function (nV) {
      var innerContent = nV.find('.accordion__content-inner')[0],
        maxHeight = $(innerContent).outerHeight(),
        content = nV.find('.accordion__content')[0];
      if (!content.style.height || content.style.height === '0px') {
        $(content).css('height', maxHeight);
      } else {
        $(content).css('height', '0px');
      }
    };
    var toggleClasses = function (event) {
      var clickedItem = event.currentTarget;
      var currentItem = $(clickedItem).closest('[data-binding="expand-accordion-item"]');
      var clickedContent = $(currentItem).find('.accordion__content')
      $(currentItem).toggleClass(expandedClass);
      setHeight(currentItem);

      if ($(currentItem).hasClass('is-expanded')) {
        $(clickedItem).attr('aria-expanded', 'true');
        $(clickedContent).attr('aria-hidden', 'false');
      } else {
        $(clickedItem).attr('aria-expanded', 'false');
        $(clickedContent).attr('aria-hidden', 'true');
      }
    }
    triggerBtn.on('click', event, function (e) {
      e.preventDefault();
      toggleClasses(event);
    });
    // open tabs if the spacebar or enter button is clicked whilst they are in focus
    $(triggerBtn).on('keydown', event, function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        toggleClasses(event);
      }
    });
  });
});

if (pageType !== 'search'){
  $(".CollectionToolbar__Item").on('click', function () {
    $('body').addClass("megamenu-open");
  });
}
$(".Drawer__Close").on('click', function () {
  $('body').removeClass("megamenu-open");
});

var onScrollThrottled = throttle(function(){
  var st = window.pageYOffset || document.documentElement.scrollTop || 0;
  if (st > 1) $('.pdp-product-gallery').addClass('stickyClass');
  else $('.pdp-product-gallery').removeClass('stickyClass');

  if ($('#collection-sort-popover').attr('aria-hidden') == 'false') {
    $('.CollectionToolbar__Item--sort').click();
  }
}, 100);

window.addEventListener('scroll', onScrollThrottled, { passive: true });

/* Handling Screen Freeze Issue */
function stopScreenFreeze() {
  $('#custom-stones').children().find('button').click(function () {
    $(this).attr('aria-expanded', true)
  })
  $(".ProductForm__Option").find('button').click(function () {
    setTimeout(() => {
      if ($(this).attr("aria-expanded") == "true") {
        $("body").addClass("is-rc-open").removeClass("is-rc-close");
      } else {
        $("body").removeClass("is-rc-open").addClass("is-rc-close");
        $("html").removeClass("no-scroll")
      }
    }, 150)
  });
}

/* Handling Screen Freeze Issue for VOW */
if (currentProductTemplate && currentProductTemplate === 'vow.engagement.rings') {
  $(".product__select-list").find('button').click(function () {
    setTimeout(() => {
      if ($(this).attr("aria-expanded") == "true") {
        $("body").addClass("is-rc-open").removeClass("is-rc-close");
      } else {
        $("body").removeClass("is-rc-open").addClass("is-rc-close");
      }
    }, 100)
  });
}

var salePriceVariants = [];
var showSalePriceDebounced = debounce(showSalePriceOnSearchBar, 500);
$('.Search__Input').off('keyup.sale').on('keyup.sale', showSalePriceDebounced);

/* Get ids from .showSalePriceOnSearch and show the salesPrice on UI */
function showSalePriceOnSearchBar() {
  $('.showSalePriceOnSearch').each(async function () {
    var productId = parseInt($(this).attr('data-product-id'));
    var variantId = parseInt($(this).attr('data-variant-id'));
    var variantDetails = $(this).attr("data-variant-detail");
    var variantSku = $(this).attr("data-variant-sku");
    var sectionId = $(this).attr("data-section-id");
    var variantPrice = parseFloat(variantDetails / 100);
    var variant = $(this).attr("data-variant") ? JSON.parse($(this).attr("data-variant")) : {};
    var regPrice = parseFloat(variant?.price)/100;
    var compareAtPrice = parseFloat(variant?.compare_at_price)/100;
    var vipPrice = $(this).attr("data-vip-price") ? parseFloat($(this).attr("data-vip-price")) : 0;
    var vvipPrice = $(this).attr("data-vvip-price") ? parseFloat($(this).attr("data-vvip-price")) : 0;
    var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
    var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");
    var salePrice = 0;
    var showPercentOff = false;
    var enableCompareAtPrice= false;
    
    /* Sale Price for All Visitors */
    if (showSalePriceGlobal && showSalePriceGlobal === true) {
      salePrice = $(this).attr("data-sale-price") ? parseFloat($(this).attr("data-sale-price")) : 0;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Sale Price to show for VIP Visitors */
    if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVIPParam) {
      salePrice = vipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Sale Price to show for VVIP Visitors */
    if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam) {
      salePrice = vvipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Locked Private Sale: Sale Price to show for VIP Visitors */
    if (showVIPPrivateSale && showVIPPrivateSale === true && checkVIPUser && checkVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVIPParamPrivateSale) {
      salePrice = vipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }
    /* Locked Private Sale: Sale Price to show for VVIP Visitors */
    if (showVVIPPrivateSale && showVVIPPrivateSale === true && checkVVIPUser && checkVVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVVIPParamPrivateSale) {
      salePrice = vvipPrice;
      showPercentOff = true;
      enableCompareAtPrice = true
    }

    var formattedSalePrice = salePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formattedSalePrice = formatPriceFunc(formattedSalePrice); /* Removing decimal if .00 found in the price */
    var formattedCompareAtPrice = compareAtPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formattedCompareAtPrice = formatPriceFunc(formattedCompareAtPrice); /* Removing decimal if .00 found in the price */
    var formattedVariantPrice = variantPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    formattedVariantPrice = formatPriceFunc(formattedVariantPrice); /* Removing decimal if .00 found in the price */

    /* Discount percent Implementation */
    var percentageOff = ''
    if (showPercentOff == true) {
      percentageOff = (((regPrice - salePrice) / regPrice) * 100).toFixed(2)
      percentageOff = percentageOff.replace(/\.00$/, '') + "% Off";
    }
    if (compareAtPrice && compareAtPrice != null && compareAtPrice > 0 && compareAtPrice > regPrice && enableCompareAtPrice == true) {
      percentageOff = (((compareAtPrice - regPrice) / compareAtPrice) * 100).toFixed(2)
      percentageOff = percentageOff.replace(/\.00$/, '') + "% Off";
    }
    if ((salePrice != '' && salePrice > 0) || (compareAtPrice != null && compareAtPrice > 0)) {
      if (compareAtPrice && compareAtPrice > regPrice) {
        var startingAtText = $(this).parent().find(".upwardWrapper").text().includes(prefixOfPrice);
        var removeStartingAt = $(this).parent().find(".upwardWrapper").text().replace(prefixOfPrice, "");
        $(this).parent().find(".upwardWrapper").text(removeStartingAt);
        $(this).parent().find(".upwardWrapper").css("color", salePriceColorGlobal);
        $('.showSalePriceOnSearch').css("margin-bottom",'0px')
        if($(`#${variantId}_${sectionId}_${variantSku}_compareAt`).length === 0){
          $(`#${variantId}_${sectionId}_${variantSku}`).after('<div id="compare-at-'+ productId +'">' + (startingAtText ? '<span>'+prefixOfPrice+ " " +'</span>' : '') + '<span class="comapreAt strikeThrough" id="' + variantId + "_" + sectionId + "_" + variantSku + '_compareAt"> ' + "$" + formattedCompareAtPrice + '</span><span class="comapreAt" id="' + variantId + "_" + sectionId + "_" + variantSku + '_percentOff" style=color:' + showPercentageOffColorGlobal + '> ' + percentageOff + '</span></div>')
        }
        $(`#${variantId}_${sectionId}_${variantSku}`).parent().find('span.money').removeClass("strikeThrough").css("color", salePriceColorGlobal);
        $(`#${variantId}_${sectionId}_${variantSku}`).parent().addClass("textUpword-collection")
        if(pageType === 'product') {
          if (checkAddonFlyout && checkAddonFlyout !== null) {
            var $container = $('.products-list-details.textUpword-collection');
            var $link = $container.find(`#change-position-${productId}`);
            var $compareAtDiv = $container.find(`#compare-at-${productId}`);
            $link.insertAfter($compareAtDiv);
          }
        }
      } else {
        if (salePrice && salePrice < regPrice) {
          $(`#${variantId}_${sectionId}_${variantSku}`).html(`$${formattedSalePrice}`).css("color", salePriceColorGlobal);
          $(`#${variantId}_${sectionId}_${variantSku}`).parent().find('span.money').addClass('strikeThrough').css("color", "#000");
          if ($(`#${variantId}_${sectionId}_${variantSku}`).parent().find(`#${variantId}_${sectionId}_${variantSku}_percentOff`).length !== 0) {
            $(`#${variantId}_${sectionId}_${variantSku}`).parent().find(`#${variantId}_${sectionId}_${variantSku}_percentOff`).html(" " + percentageOff);
          } else {
            $(`#${variantId}_${sectionId}_${variantSku}`).parent().find('span.money').after('<span id="' + variantId + "_" + sectionId + "_" + variantSku + '_percentOff" style=color:' + showPercentageOffColorGlobal + '> ' + percentageOff + '</span>')
          }
          $(`#${variantId}_${sectionId}_${variantSku}`).parent().removeClass("textUpword-collection")
        }
      }
    }
  })
}

/* Enable Add to cart and Removing Disabled class */
function enableAddToCartButton() {
  var checkButtonText = $('.ProductForm__AddToCart').text().toLowerCase();
  if (checkButtonText.indexOf('sold out') > -1 && currentProductTemplate !== 'sold-out-er-build-your-ow' && currentProductTemplate !== 'sold-out-er-customize' && currentProductTemplate !== 'fluted-heart') {
    disableAddToCartButton();
    var buttonText = $('.ProductForm__AddToCart').text();
    if(buttonText.toLowerCase() === "sold out"){
      $('.ProductForm__AddToCart').text(buttonText);
    }
  } else {
    $(".ProductForm__AddToCart").prop('disabled', false);
  }
}

/* Disable Add to cart and Removing Disabled class */
function disableAddToCartButton() {
  $(".ProductForm__AddToCart").prop('disabled', true);
}

var scrollEnabledCalled = false;
function enableScroll() {
  if (!scrollEnabledCalled) {
    $('body').css('overflow', '');
    $(window).off('scroll.prevent');
    scrollEnabledCalled = true;
  }
}

/* Managing Delays */
function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}  

let cleanOrphanGhostProductsRan = false;

async function cleanOrphanGhostProducts() {
  if (cleanOrphanGhostProductsRan) return;
  cleanOrphanGhostProductsRan = true;

  const ENGRAVING_VARIANT_ID = 40218981892184;

  const cart = await fetch('/cart.js').then(res => res.json());
  const items = cart.items;

  const variantIdsInCart = new Set(items.map(i => Number(i.variant_id)));
  const associatedKeysInCart = new Set();
  const itemsByVariantId = new Map();
  
  for (const item of items) {
    const id = Number(item.variant_id);
    if (!itemsByVariantId.has(id)) itemsByVariantId.set(id, []);
    itemsByVariantId.get(id).push(item);
  }

  /* ========= HELPERS ========= */
  const isDynamicGiftwrap = (props) =>
    props?._giftwrap === "true" && props?._gwia === "true";

  const isPdpGiftwrap = (props) =>
    props?._giftwrap === "true" && props?._gwia !== "true";

  /* ========= MAIN ITEMS ========= */
  const mainItemsNeedingEngraving = [];

  for (const item of items) {
    const props = item.properties || {};
    const isMain =
      props._engraving_required === "Yes" ||
      !!props._Custom_Stone_1 ||
      isDynamicGiftwrap(props); // Only dynamic giftwrap

    if (isMain && props._associated_unique_key) {
      associatedKeysInCart.add(props._associated_unique_key);
      if (props._engraving_required === "Yes") {
        mainItemsNeedingEngraving.push(item);
      }
    }
  }

  const ghostItemKeysToRemove = [];
  const engravingGhostsToAdd = [];

  /* ========= STEP 1: REMOVE ORPHANS ========= */
  for (const item of items) {
    const props = item.properties || {};
    const lineKey = item.key;
    const variantId = Number(item.variant_id);

    let isGhost = false;
    let isOrphan = false;

    const associatedKey = props._associated_unique_key;

    /* == ENGRAVING == */
    if (props._engrave_associated_var_id) {
      isGhost = true;
      const mainVarId = Number(props._engrave_associated_var_id);
      const keyMatch = associatedKeysInCart.has(associatedKey);
      if (!variantIdsInCart.has(mainVarId) || !keyMatch) {
        isOrphan = true;
      }
    }
    /* == STONE == */
    else if (props._stone_associated_variant_id) {
      isGhost = true;
      const mainVarId = Number(props._stone_associated_variant_id);
      const keyMatch = associatedKeysInCart.has(associatedKey);
      let validToiEtMoi = false;
      for (const item of items) {
        const mainProps = item.properties || {};
        if (
          mainProps._associated_unique_key === associatedKey &&
          (
            Number(mainProps._Emerlad_stone_v_id) === variantId ||
            Number(mainProps._Pearstone_v_id) === variantId
          )
        ) {
          validToiEtMoi = true;
          break;
        }
      }

      if ((!variantIdsInCart.has(mainVarId) || !keyMatch) && !validToiEtMoi) {
        isOrphan = true;
      }
    }
    /* == COMPLIMENTARY == */
    else if (props._complimentary_associated_variant_id) {
      isGhost = true;
      const mainVarId = Number(props._complimentary_associated_variant_id);
      const mainItems = itemsByVariantId.get(mainVarId) || [];
      const matchedMain = mainItems.find(mainItem => {
        const mainProps = mainItem.properties || {};
        const sameKey = mainProps._associated_unique_key === associatedKey;
        const complimentaryAllowed = mainProps._complimentory_wrap_selected !== "no";
        const hasValidGiftwrap =
          mainProps._giftwrap === "true"
          ? true // both PDP + dynamic allowed
          : true; // also allow no giftwrap case
        return sameKey && complimentaryAllowed && hasValidGiftwrap;
      });
      if (!matchedMain) {
        isOrphan = true;
      }
    }
    if (isGhost && isOrphan) {
      ghostItemKeysToRemove.push(lineKey);
    }
  }

  /* ========= STEP 2: ADD MISSING ENGRAVING ========= */
  for (const mainItem of mainItemsNeedingEngraving) {
    const props = mainItem.properties || {};
    const assocKey = props._associated_unique_key;
    const hasEngravingGhost = items.some(i =>
      i.variant_id == ENGRAVING_VARIANT_ID &&
      i.properties &&
      i.properties._engrave_associated_var_id == mainItem.variant_id &&
      i.properties._associated_unique_key == assocKey
    );
    if (!hasEngravingGhost) {
      engravingGhostsToAdd.push({
        id: ENGRAVING_VARIANT_ID,
        quantity: mainItem.quantity,
        properties: {
          _engrave_associated_var_id: String(mainItem.variant_id),
          _associated_unique_key: assocKey
        }
      });
    }
  }

  /* ========= STEP 2.5: SYNC QUANTITIES ========= */
  const ghostQuantityUpdates = {};
  for (const item of items) {
    const props = item.properties || {};
    let mainVarId;
    let mainItem;
    if (props._engrave_associated_var_id) {
      mainVarId = Number(props._engrave_associated_var_id);
    } else if (props._stone_associated_variant_id) {
      mainVarId = Number(props._stone_associated_variant_id);
    } else if (
      props._associated_variant_id &&
      !(props._giftwrap === "true" && props._gwia !== "true") // Exclude metafield giftwrap only
    ) {
      mainVarId = Number(props._associated_variant_id);
    } else if (props._complimentary_associated_variant_id) {
      mainVarId = Number(props._complimentary_associated_variant_id);
    }

    if (mainVarId) {
      const mainItems = itemsByVariantId.get(mainVarId) || [];
      mainItem = mainItems.find(mi =>
        mi.properties &&
        mi.properties._associated_unique_key === props._associated_unique_key
      );
      if (mainItem && item.quantity !== mainItem.quantity) {
        ghostQuantityUpdates[item.key] = mainItem.quantity;
      }
    }
  }

  if (Object.keys(ghostQuantityUpdates).length > 0) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: ghostQuantityUpdates })
    });
  }

  /* ========= STEP 3: REMOVE ========= */
  if (ghostItemKeysToRemove.length > 0) {
    const updates = {};
    ghostItemKeysToRemove.forEach(key => {
      updates[key] = 0;
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  /* ========= STEP 4: ADD ========= */
  if (engravingGhostsToAdd.length > 0) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: engravingGhostsToAdd })
    });
  }

  /* ========= STEP 5 ========= */
  await fetch("/cart.js").then(r => r.json());
  await delay(1000);

  /* ========= STEP 6 ========= */
  if (
    ghostItemKeysToRemove.length > 0 ||
    engravingGhostsToAdd.length > 0 ||
    Object.keys(ghostQuantityUpdates).length > 0
  ) {
    if (window.location.pathname === '/cart') {
      setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } else {
    console.log("No orphan ghosts or missing engraving ghosts found.");
  }
}

/* ========= Loading the Static Image section on collection page ========= */
function renderStaticImgShopTheLook(elem) {
  var staticImgShopTheLook = $(".static-image-shop-the-look");
  var collectionList = $('.ProductList .Grid__Cell');
  var currentPage = parseInt(elem.queryParams.page);
  if (collectionList.length) {
    /* Place Static Image Shop the look component in between the grid only on page 1. */
    if (currentPage === 1 && staticImgShopTheLook.length) {
      collectionList.slice(4, 8).wrapAll('<div class="static-img-grid"><div class="static-img-product-grid"></div></div>');
      staticImgShopTheLook.clone(true).addClass("static-img-shop-the-look-wrapper").appendTo(".static-img-grid");
      staticImgShopTheLook.filter(':not(.static-img-shop-the-look-wrapper)').hide();
    }
  }
}

/* ========= Loading the List breaker (Bold Geometry Section) on Collection Grid ========= */
function renderListBreakerComp(elem) {
  var listBreakerComponent = $(".collection-list-breaker");
  var collectionList = $('.ProductList .Grid__Cell');
  var Loader = $('.spinner-container');
  var currentPage = parseInt(elem.queryParams.page);
  // Detect mobile (adjust breakpoint if needed)
  var isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (collectionList.length && $(".collection-list-breaker.collection-list-breaker-cloned").length === 0) {
    collectionList.each(function (i) {
      /* === Place list breaker component in between the grid only on page 1. === */
      var appendAfterPosition = isMobile ? 5 : 7;
      if (currentCollectionId === '301336658008') appendAfterPosition = isMobile ? 5 : 3;
      if (currentCollectionId === '310079848536') appendAfterPosition = 5;
      if (currentCollectionId === '312891801688') appendAfterPosition = 5;
      
      if (currentPage === 1 && i === appendAfterPosition && listBreakerComponent.length) {
        listBreakerComponent.clone(true).addClass("collection-list-breaker-cloned").insertAfter($(this)).fadeIn(400);
        listBreakerComponent.filter(':not(.collection-list-breaker-cloned)').hide();
      }
      $(".collection-list-breaker").toggleClass("hide", currentPage !== 1);
    });
    /* === Show a loader so that there is no jump in the page and animate things smoothly. === */
    if (Loader.length) {
      Loader.fadeOut(400, function () {
        $(this).hide();
      });
    }
  }
}

/*** ========= Reinitializing the flickity slider for mobile after search ========= ***/
function reInitializeFlickityAfterSearch() {
  if (!window.Flickity) return; // guard
  var nodeList = document.querySelectorAll('.js-flickity');
  for (var i = 0; i < nodeList.length; i++) {
    var flkty = window.Flickity && window.Flickity.data ? Flickity.data(nodeList[i]) : null;
    if (!flkty) {
      var flktyData = { fullscreen: true, pageDots: false, prevNextButtons: false, lazyLoad: 1 };
      new Flickity(nodeList[i], flktyData);
    }
  }
  if (localStorage.getItem("scrollToTop") !== 'true') window.scroll(0, 0);
  setTimeout(function(){ localStorage.removeItem("scrollToTop"); }, 3000);
  if (window.innerWidth < 1008) {
    $(".CollectionToolbar__Item").off('click.mobile').on('click.mobile', function(){ $('body').addClass('is-rc-open'); });
    $('.Popover__Close, .Drawer__Close').off('click.mobile').on('click.mobile', function(){ $('body').removeClass('is-rc-open'); });
    $('.Popover__Value').off('click.mobile').on('click.mobile', function(){ $('body').removeClass('is-rc-open'); });
  }
}